<template>
  <div class="admin-container">
    <teleport to="body">
      <div class="mc-image-preview" :class="{ active: imagePreviewActive }" v-show="!!imagePreviewUrl" @click.self="closeImagePreview">
        <div class="mc-image-preview-content">
          <img :src="imagePreviewUrl" class="mc-image-preview-img" />
          <button type="button" class="mc-image-preview-close" @click="closeImagePreview">×</button>
        </div>
      </div>
    </teleport>
    <nav class="admin-nav">
      <div class="admin-nav-left">
        <div class="admin-nav-brand">
          <div class="admin-brand-logo"></div>
          <div class="admin-brand-text">
            <div class="admin-brand-title">云边小镇</div>
            <div class="admin-brand-sub">后台管理</div>
          </div>
        </div>

        <div class="admin-nav-tabs">
          <button class="nav-tab-btn" :class="{ active: activeTab === 'main' }" @click="activeTab = 'main'">后台管理</button>
          <button class="nav-tab-btn" :class="{ active: activeTab === 'mail' }" @click="activeTab = 'mail'">
            邮件管理
            <div class="mc-nav-badge" v-if="unreadMailCount > 0">{{ unreadMailCount > 99 ? '99+' : unreadMailCount }}</div>
          </button>
          <button class="nav-tab-btn" :class="{ active: activeTab === 'updateLog' }" @click="activeTab = 'updateLog'">更新日志</button>
          <button class="nav-tab-btn" :class="{ active: activeTab === 'traffic' }" @click="activeTab = 'traffic'">流量监控</button>
        </div>
      </div>

      <div class="admin-nav-actions">
        <a href="javascript:void(0)" @click="goHome" class="back-link">&lt; 返回首页</a>
        <button type="button" class="back-link mc-nav-btn" @click="logoutAdmin">退出登录</button>
      </div>
    </nav>

    <div class="admin-content">
      <transition name="admin-tab-fade" mode="out-in" @after-enter="handleAdminTabAfterEnter">
        <div v-if="activeTab === 'traffic'" key="traffic" class="traffic-panel">
          <section class="admin-section">
            <h2 class="section-title">流量监控</h2>
            <div class="section-content traffic-content">
              <div class="traffic-left">
                <div class="traffic-toolbar">
                  <button
                    v-for="p in trafficPeriods"
                    :key="p.value"
                    class="mc-btn traffic-period-btn"
                    :class="{ active: trafficPeriod === p.value }"
                    @click="changeTrafficPeriod(p.value)"
                  >
                    {{ p.label }}
                  </button>
                  <button class="mc-btn" @click="loadTrafficStats">刷新</button>
                </div>
                <div class="traffic-table-wrapper">
                  <table class="traffic-table">
                    <thead>
                      <tr>
                        <th>IP 地址</th>
                        <th>省份</th>
                        <th>城市</th>
                        <th>访问次数</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="trafficStats.length === 0">
                        <td colspan="4" class="traffic-empty">当前时间段暂无访问数据</td>
                      </tr>
                      <tr v-for="(row, idx) in trafficStats" :key="row.ip + '-' + idx" :class="{ 'is-top': idx === 0 }">
                        <td>{{ row.ip }}</td>
                        <td>{{ row.province || '-' }}</td>
                        <td>{{ row.city || '-' }}</td>
                        <td>{{ row.count }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="traffic-right">
                <div class="traffic-map-shell">
                  <div class="traffic-map-title">GEOGRAPHICAL ACCESS MONITOR</div>
                  <div class="traffic-map-status">
                    <div>[ 系统状态 ]: {{ trafficStats.length > 0 ? '链路稳定' : '等待访问...' }}</div>
                    <div>[ 目标节点 ]:  北京主机(8.148.193.15)</div>
                    <div>[ 协议 ]: TCP/IP SECURE</div>
                    <div>[ 经纬度 ]: 116.405285 39.904989</div>
                  </div>
                  <div ref="trafficMapRef" class="traffic-map-container"></div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- 更新日志管理模块 -->
        <div v-else-if="activeTab === 'updateLog'" key="updateLog" class="update-log-panel">
          <section class="admin-section">
            <h2 class="section-title">系统更新日志</h2>
            <div class="section-content">
              <button class="mc-btn mc-btn-primary" @click="openUpdateLogModal(null)">记录新版本</button>
              
              <div class="update-timeline">
                <div v-if="updateLogs.length === 0" class="empty-timeline">暂无更新记录</div>
                <div v-for="log in updateLogs" :key="log.id" class="timeline-node">
                  <div class="node-dot"></div>
                  <div class="node-content">
                    <div class="node-header">
                      <span class="node-version">V{{ log.version }}</span>
                      <span class="node-date">{{ log.updateTime }}</span>
                    </div>
                    <div class="node-body">{{ log.content }}</div>
                    <div class="node-actions">
                      <button class="mc-btn-small" @click="openUpdateLogModal(log)">修改</button>
                      <button class="mc-btn-small mc-btn-danger" @click="deleteUpdateLog(log.id)">抹除</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- 邮件管理模块 -->
        <div v-else-if="activeTab === 'mail'" key="mail" class="mail-admin-panel">
          <section class="admin-section">
          <h2 class="section-title">玩家投信批阅</h2>

          <div class="mail-toolbar">
            <div class="mail-toolbar-group search-group">
              <span class="group-label">搜索</span>
              <input v-model="mailSearch" class="mc-input mail-search" type="text" placeholder="昵称 / 内容 / 联系方式..." />
            </div>
            
            <div class="toolbar-divider"></div>
            
            <div class="mail-toolbar-group filter-group">
              <span class="group-label">筛选</span>
              <div class="mc-select-wrapper">
                <span class="select-display-text">{{ mailTypeFilter === 'all' ? '全部类型' : getMailTypeLabel(mailTypeFilter) }}</span>
                <select v-model="mailTypeFilter" class="mc-input mail-select">
                  <option value="all">全部类型</option>
                  <option v-for="t in mailTypeOptions" :key="t.key" :value="t.key">{{ t.label }}</option>
                </select>
              </div>
              <div class="mc-select-wrapper">
                <span class="select-display-text">{{ mailSort === 'new' ? '最新优先' : '最早优先' }}</span>
                <select v-model="mailSort" class="mc-input mail-select">
                  <option value="new">最新优先</option>
                  <option value="old">最早优先</option>
                </select>
              </div>
            </div>

            <div class="toolbar-divider"></div>

            <div class="mail-toolbar-group action-group">
              <span class="group-label">操作</span>
              <button class="mc-btn mc-btn-unread" :class="{ active: mailUnreadOnly }" @click="mailUnreadOnly = !mailUnreadOnly">
                仅未读
              </button>
              <button class="mc-btn" :class="{ active: mailBatchMode }" @click="toggleMailBatchMode">
                批量管理
              </button>
              <button v-if="mailBatchMode" class="mc-btn mc-btn-danger" :disabled="selectedMailCount === 0" @click="confirmBatchDelete">
                销毁 ({{ selectedMailCount }})
              </button>
              <button class="mc-btn" @click="loadMailList">刷新</button>
            </div>
          </div>

          <div class="section-content">
            <div class="mail-grid">
              <div v-if="filteredMailList.length === 0" class="data-item" style="justify-content:center; color:#bbb; grid-column: 1 / -1;">
                暂无邮件反馈
              </div>
              <div v-for="m in filteredMailList" :key="m.id" 
                   class="mail-card" 
                   :class="{ 
                     'mail-read': m.status !== 0, 
                     ['mail-type-' + normalizeMailType(m.type)]: true, 
                     'mail-batch-mode': mailBatchMode,
                     'mail-selected': selectedMailIds.has(m.id)
                   }"
                   @click="mailBatchMode ? toggleMailSelection(m) : openMailDetail(m)">
                <div v-if="mailBatchMode" class="mail-select-box" :class="{ disabled: !isMailSelectable(m), checked: selectedMailIds.has(m.id) }" @click.stop="toggleMailSelection(m)">
                  <span class="mail-select-tick">✓</span>
                </div>
                <!-- 信封装饰线 -->
                <div class="mail-envelope-flap"></div>
                <div class="mail-envelope-crease"></div>
                
                <div class="mail-card-header">
                  <div style="display: flex; align-items: center; gap: 8px; position: relative; z-index: 2;">
                    <span class="mail-card-type">{{ getMailTypeLabel(m.type) }}</span>
                    <span v-if="m.userId" class="mail-member-badge">成员</span>
                  </div>
                  <span class="mail-card-time" style="position: relative; z-index: 2;">{{ formatDateTime(m.createTime).split(' ')[0] }}</span>
                </div>
                <div class="mail-card-body" style="position: relative; z-index: 2;">
                  <div class="mail-card-nickname">{{ m.nickname }}</div>
                  <div class="mail-card-preview">{{ m.content }}</div>
                </div>
                <div class="mail-card-footer" style="position: relative; z-index: 2;">
                  <div class="mail-status-seal" :class="{ 'unread': m.status === 0, 'read': m.status === 1, 'replied': m.status === 2 }">
                    {{ m.status === 0 ? '待阅' : (m.status === 1 ? '已阅' : '已回') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- 原有管理内容 -->
      <div v-else key="main">
        <!-- 用户管理 -->
        <section class="admin-section">
        <h2 class="section-title">用户管理</h2>
        <div class="section-content">
          <div class="data-list">
            <div v-if="users.length === 0" class="data-item" style="justify-content:center; color:#bbb;">
              暂无用户
            </div>

            <div v-for="u in users" :key="u.id" class="data-item building-item user-item">
              <div class="item-content">
                <img :src="u.avatarUrl || 'https://minotar.net/avatar/steve/64'" class="building-thumb" style="image-rendering: pixelated;" />
                <div class="item-info">
                  <span class="item-text">{{ u.nickname }} ({{ u.email }})</span>
                  <span class="item-meta">审批: {{ u.approved === 1 ? '已通过' : '待审批' }} | 状态: {{ u.status === 1 ? '启用' : '禁用' }}</span>
                  <span v-if="u.bio" class="item-meta" style="color: #9ae054;">说明: {{ u.bio }}</span>
                </div>
              </div>
              <div class="item-actions" style="flex-wrap: nowrap; justify-content: flex-end; gap: 10px;">
                <button v-if="u.approved !== 1" class="mc-btn-small" @click="approveUser(u.id)">通过</button>
                <button v-if="u.approved !== 1" class="mc-btn-small mc-btn-danger" @click="openRejectModal(u)">拒绝</button>

                <button v-if="u.approved === 1 && u.status !== 1" class="mc-btn-small" @click="enableUser(u.id)">启用</button>
                <button v-if="u.approved === 1 && u.status === 1" class="mc-btn-small mc-btn-danger" @click="openDisableModal(u)">禁用</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="mc-modal-mask" :class="{ active: rejectModalActive }" @click.self="closeRejectModal">
        <div class="mc-modal" :class="{ active: rejectModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">拒绝用户</h3>
          <div class="mc-modal-scroll">
            <div style="font-size:12px; color:#000;">拒绝理由（将同步发送到用户邮箱，并逻辑删除账号）：</div>
            <input v-model="rejectReason" type="text" class="mc-input" placeholder="请输入拒绝原因..." />
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeRejectModal">取消</button>
            <button class="mc-btn mc-btn-primary" :disabled="!rejectTarget" @click="confirmRejectUser">确认拒绝</button>
          </div>
        </div>
      </div>

      <div class="mc-modal-mask" :class="{ active: disableModalActive }" @click.self="closeDisableModal">
        <div class="mc-modal" :class="{ active: disableModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">禁用用户</h3>
          <div class="mc-modal-scroll">
            <div style="font-size:12px; color:#000;">原因（会实时推送踢下线）：</div>
            <input v-model="disableReason" type="text" class="mc-input" placeholder="该账号已被封禁！请联系小葱咨询原因~" />
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeDisableModal">取消</button>
            <button class="mc-btn mc-btn-primary" :disabled="!disableTarget" @click="confirmDisableUser">确认禁用</button>
          </div>
        </div>
      </div>

      <!-- 轮播图管理 -->
      <section class="admin-section">
        <h2 class="section-title">轮播图管理</h2>
        <div class="section-content">
          <button class="mc-btn mc-btn-primary" @click="openCarouselModal(null)">添加轮播图</button>
          <div class="data-list">
            <div v-for="carousel in carousels" :key="carousel.id" class="data-item building-item">
              <div class="item-content">
                <img v-if="carousel.imageUrl" :src="carousel.imageUrl" class="building-thumb" />
                <div class="item-info">
                  <span class="item-text">{{ carousel.title || '无标题' }}</span>
                  <span class="item-meta">排序: {{ carousel.sortOrder }} | {{ carousel.isActive === 1 ? '启用' : '禁用' }}</span>
                </div>
              </div>
              <div class="item-actions">
                <button class="mc-btn-small" @click="openCarouselModal(carousel)">编辑</button>
                <button class="mc-btn-small mc-btn-danger" @click="deleteCarousel(carousel.id)">删除</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 公告管理 -->
      <section class="admin-section">
        <h2 class="section-title">公告栏管理</h2>
        <div class="section-content">
          <button class="mc-btn mc-btn-primary" @click="openNoticeModal(null)">添加公告</button>
          <div class="data-list">
            <div v-for="notice in notices" :key="notice.id" class="data-item">
              <div class="item-content">
                <span class="item-type" :class="getNoticeTypeClass(notice.type)">[{{ getTypeName(notice.type) }}]</span>
                <span class="item-text">{{ notice.content }}</span>
              </div>
              <div class="item-actions">
                <button class="mc-btn-small" @click="openNoticeModal(notice)">编辑</button>
                <button class="mc-btn-small mc-btn-danger" @click="deleteNotice(notice.id)">删除</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 用户公告管理 -->
      <section class="admin-section">
        <h2 class="section-title">用户公告管理</h2>
        <div class="section-content">
          <div class="data-list">
            <div v-if="userNotices.length === 0" class="data-item" style="justify-content:center; color:#bbb;">暂无用户公告</div>
            <div v-for="n in userNotices" :key="n.id" class="data-item" style="align-items:flex-start;">
              <div class="item-content" style="gap: 12px;">
                <div class="item-info" style="gap: 6px;">
                  <span class="item-text">用户: {{ n.nickname || ('ID:' + n.userId) }} | {{ n.content }}</span>
                  <span class="item-meta">创建: {{ formatDateTime(n.createdAt) }} | 到期: {{ formatDateTime(n.expireAt) }} | 状态: {{ n.isDelete === 1 ? '隐藏' : '可见' }}</span>
                </div>
              </div>
              <div class="item-actions" style="flex-wrap: wrap; justify-content:flex-end;">
                <button class="mc-btn-small" @click="openUserNoticeModal(n)">编辑</button>
                <button class="mc-btn-small mc-btn-danger" @click="adminDeleteUserNotice(n.id)">删除</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 地图标点管理 -->
      <section class="admin-section">
        <h2 class="section-title">地图标点管理</h2>
        <div class="section-content">
          <div class="map-toolbar">
            <div class="map-toolbar-left">
              <button class="mc-btn mc-btn-primary" @click="openMapUploadModal">上传地图</button>
            </div>
            <div class="map-toolbar-right">
              <div class="mc-switch" :class="{ on: mapLocked }" @click="mapLocked = !mapLocked" role="switch" :aria-checked="mapLocked">
                <div class="mc-switch-track">
                  <div class="mc-switch-thumb"></div>
                </div>
                <div class="mc-switch-label">地图锁定</div>
              </div>
              <div class="map-lock-hint">{{ mapLocked ? '开：可拖动标点' : '关：可拖动地图' }}</div>
            </div>
          </div>

          <teleport to="body">
            <div class="mc-modal-mask" :class="{ active: mapUploadModalActive }" @click.self="closeMapUploadModal">
              <div class="mc-modal" :class="{ active: mapUploadModalActive }">
                <h3 style="color: #000; margin: 0; font-size: 14px;">上传地图</h3>
                <div class="mc-modal-scroll">
                  <div>
                    <label style="color: #000; font-size: 12px; display: block; margin-bottom: 5px;">选择图片：</label>
                    <input ref="mapFileInput" type="file" accept="image/*" @change="handleMapFileChange" />
                    <div style="font-size: 10px; color: #555; margin-top: 6px;">建议：上传一张清晰的地图图片（PNG/JPG）</div>
                  </div>
                  <div v-if="mapUploadPreview || mapImageUrl" style="margin-top: 8px;">
                    <div style="color:#000; font-size:12px; margin-bottom:6px;">预览：</div>
                    <img :src="mapUploadPreview || mapImageUrl" style="width:100%; max-height:240px; border: 3px solid #000; object-fit: contain; background:#111;" />
                  </div>
                </div>
                <div class="modal-btns">
                  <button class="mc-btn" @click="closeMapUploadModal">取消</button>
                  <button class="mc-btn mc-btn-primary" :disabled="!mapUploadFile" @click="confirmUploadMapImage">确认上传</button>
                </div>
              </div>
            </div>
          </teleport>
          <div class="map-preview">
            <div id="admin-map" class="map-container"></div>
          </div>
          <div class="data-list">
            <div v-for="marker in markers" :key="marker.id" class="data-item">
              <div class="item-content">
                <span class="item-text">{{ marker.name }}</span>
                <span class="item-meta">坐标: ({{ marker.lat }}, {{ marker.lng }})</span>
              </div>
              <div class="item-actions">
                <button class="mc-btn-small" @click="openMarkerModal(marker)">编辑</button>
                <button class="mc-btn-small mc-btn-danger" @click="deleteMarker(marker.id)">删除</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 居民管理 -->
      <section class="admin-section">
        <h2 class="section-title">小镇居民管理</h2>
        <div class="section-content">
          <button class="mc-btn mc-btn-primary" @click="openResidentModal(null)">添加居民</button>
          <div class="data-list">
            <div v-for="resident in residents" :key="resident.id" class="data-item">
              <div class="item-content">
                <span class="item-text">{{ resident.name }} - {{ resident.title }}</span>
              </div>
              <div class="item-actions">
                <button class="mc-btn-small" @click="openResidentModal(resident)">编辑</button>
                <button class="mc-btn-small mc-btn-danger" @click="deleteResident(resident.id)">删除</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 建筑管理 -->
      <section class="admin-section">
        <h2 class="section-title">小镇建筑展示管理</h2>
        <div class="section-content">
          <div class="mc-filter-bar">
            <div class="mc-filter-title">分类查看</div>
            <button class="mc-filter-btn" :class="{ active: buildingFilter === 'all' }" @click="buildingFilter = 'all'">全部</button>
            <button class="mc-filter-btn" :class="{ active: buildingFilter === 'user' }" @click="buildingFilter = 'user'">用户</button>
            <button class="mc-filter-btn" :class="{ active: buildingFilter === 'admin' }" @click="buildingFilter = 'admin'">管理员</button>
          </div>
          <button class="mc-btn mc-btn-primary" @click="openBuildingModal(null)">添加建筑</button>
          <div class="data-list">
            <div v-for="building in filteredBuildings" :key="building.id" class="data-item building-item">
              <div class="item-content">
                <img v-if="building.coverImage" :src="building.coverImage" class="building-thumb" @click="goBuildingDetail(building)" style="cursor: pointer;" />
                <div class="item-info">
                  <span class="item-text">
                    {{ building.name }}
                    <span v-if="isUserPublishedBuilding(building)" class="mc-user-tag">
                      <span class="mc-user-tag-dash">-</span>
                      <span class="mc-user-tag-name">{{ getUserNickname(building.userId) }}</span>
                    </span>
                  </span>
                  <span class="item-meta">{{ building.subtitle }}</span>
                </div>
              </div>
              <div class="item-actions">
                <button class="mc-btn-small" @click="openBuildingModal(building)">编辑</button>
                <button class="mc-btn-small mc-btn-danger" @click="deleteBuilding(building.id)">删除</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 编年史管理 -->
      <section class="admin-section">
        <h2 class="section-title">小镇编年史管理</h2>
        <div class="section-content">
          <button class="mc-btn mc-btn-primary" @click="openChronicleModal(null)">添加编年史</button>
          <div class="data-list">
            <div v-for="chronicle in chronicles" :key="chronicle.id" class="data-item">
              <div class="item-content">
                <span class="item-text">{{ chronicle.date }} | {{ chronicle.title }}</span>
                <span class="item-meta">{{ chronicle.content.substring(0, 50) }}...</span>
              </div>
              <div class="item-actions">
                <button class="mc-btn-small" @click="openChronicleModal(chronicle)">编辑</button>
                <button class="mc-btn-small mc-btn-danger" @click="deleteChronicle(chronicle.id)">删除</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
      </transition>

    <!-- 邮件详情模态框 (信件风格) -->
    <teleport to="body">
      <div class="mail-detail-overlay" :class="{ active: mailDetailModalActive }" @click.self="closeMailDetail">
        <transition name="mail-paper-fade">
          <div v-if="mailDetailModalActive && selectedMail" class="mail-paper">
            <div class="mail-paper-content">
              <div class="mail-paper-header">
                <div class="mail-postmark">YUN TOWN</div>
                <div class="mail-paper-meta">
                  <div class="mail-paper-row">
                    <span class="label">FROM:</span>
                    <span class="value">{{ selectedMail.nickname }}</span>
                  </div>
                  <div class="mail-paper-row">
                    <span class="label">TYPE:</span>
                    <span class="value">{{ getMailTypeLabel(selectedMail.type) }}</span>
                  </div>
                  <div class="mail-paper-row">
                    <span class="label">DATE:</span>
                    <span class="value">{{ formatDateTime(selectedMail.createTime) }}</span>
                  </div>
                  <div v-if="selectedMail.email" class="mail-paper-row">
                    <span class="label">CONTACT:</span>
                    <span class="value">{{ selectedMail.email }}</span>
                  </div>
                </div>
              </div>

              <div class="mail-paper-body">
                <div class="mail-text-content">{{ selectedMail.content }}</div>
                
                <div v-if="selectedMail.replyContent" class="mail-paper-reply">
                  <div class="reply-divider"></div>
                  <div class="reply-title">MANAGEMENT REPLY:</div>
                  <div class="reply-text">{{ selectedMail.replyContent }}</div>
                </div>
              </div>

              <div class="mail-paper-footer">
                <div class="mail-actions">
                  <button class="mc-btn" @click="closeMailDetail">合上信件</button>
                  <button v-if="selectedMail.status === 0 && !selectedMail.email" 
                          class="mc-btn mc-btn-primary" 
                          @click="markMailRead(selectedMail.id); closeMailDetail()">
                    标记已阅
                  </button>
                  <button v-if="selectedMail.status === 0 && selectedMail.email" 
                          class="mc-btn mc-btn-primary" 
                          @click="openReplyModal(selectedMail); closeMailDetail()">
                    回复投信
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </teleport>

    <!-- 回复邮件模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: replyModalActive }" @click.self="replyModalActive = false">
        <div class="mc-modal" :class="{ active: replyModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">回复玩家投信</h3>
          <div class="mc-modal-scroll">
            <div v-if="replyTarget" style="font-size:12px; color:#333; display: flex; flex-direction: column; gap: 8px;">
              <div>投信人: <b>{{ replyTarget.nickname }}</b></div>
              <div>反馈原文:</div>
              <div style="background: rgba(0,0,0,0.05); padding: 8px; border: 1px solid #999; max-height: 80px; overflow-y: auto; font-style: italic;">
                {{ replyTarget.content }}
              </div>
            </div>
            <textarea v-model="replyContent" class="mc-input" rows="5" placeholder="请输入回复内容..."></textarea>
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeReplyModal">取消操作</button>
            <button class="mc-btn mc-btn-primary" @click="sendReply">发送回信</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 用户公告编辑模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: userNoticeModalActive }" @click.self="userNoticeModalActive = false">
        <div class="mc-modal" :class="{ active: userNoticeModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">编辑用户公告</h3>
          <div class="mc-modal-scroll">
            <textarea v-model="userNoticeForm.content" class="mc-input" rows="4" placeholder="输入公告内容（最多100字）..."></textarea>
            <input v-model="userNoticeForm.reason" type="text" class="mc-input" placeholder="请输入修改原因（必填）" />
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeUserNoticeModal">取消</button>
            <button class="mc-btn mc-btn-primary" :disabled="!editingUserNotice" @click="saveUserNotice">保存</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 公告模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: noticeModalActive }" @click.self="noticeModalActive = false">
        <div class="mc-modal" :class="{ active: noticeModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ editingNotice ? '编辑公告' : '添加公告' }}</h3>
          <div class="mc-modal-scroll">
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <select v-model="noticeForm.type" class="mc-input">
                <option value="top">置顶</option>
                <option value="security">安全</option>
                <option value="infrastructure">基建</option>
                <option value="normal">普通</option>
                <option value="custom">-- 自定义类型 --</option>
              </select>
              <input 
                v-if="noticeForm.type === 'custom'" 
                v-model="noticeForm.customType" 
                type="text" 
                class="mc-input" 
                placeholder="输入自定义类型名称 (如: 活动)"
              />
            </div>
            <textarea v-model="noticeForm.content" class="mc-input" rows="4" placeholder="输入公告内容..."></textarea>
            <div class="hint" style="color: rgba(0,0,0,0.45);">{{ (noticeForm.content || '').trim().length }}/不限制</div>
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeNoticeModal">取消</button>
            <button class="mc-btn mc-btn-primary" @click="saveNotice">保存</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 标点模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: markerModalActive }" @click.self="markerModalActive = false">
        <div class="mc-modal" :class="{ active: markerModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ editingMarker ? '编辑标点' : '添加标点' }}</h3>
          <div class="mc-modal-scroll">
            <input v-model="markerForm.name" type="text" class="mc-input" placeholder="标点名称" />
            <input v-model.number="markerForm.lat" type="number" class="mc-input" placeholder="纬度 (Y坐标)" step="0.1" />
            <input v-model.number="markerForm.lng" type="number" class="mc-input" placeholder="经度 (X坐标)" step="0.1" />
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeMarkerModal">取消</button>
            <button class="mc-btn mc-btn-primary" @click="saveMarker">保存</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 更新日志管理模块 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: updateLogModalActive }" @click.self="updateLogModalActive = false">
        <div class="mc-modal" :class="{ active: updateLogModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ editingUpdateLog ? '修订历史档案' : '记录新版本' }}</h3>
          <div class="mc-modal-scroll">
            <div class="mc-form-item">
              <label style="color:#000; font-size:12px;">版本号 (x.y.z)</label>
              <input v-model="updateLogForm.version" type="text" class="mc-input" placeholder="例如 1.0.1" @blur="validateVersion(false)" />
            </div>
            <div class="mc-form-item" style="margin-top:10px;">
              <label style="color:#000; font-size:12px;">更新日期</label>
              <McDatepicker v-model="updateLogForm.updateTime" :max-date="todayStr" />
            </div>
            <div class="mc-form-item" style="margin-top:10px;">
              <label style="color:#000; font-size:12px;">更新内容</label>
              <textarea v-model="updateLogForm.content" class="mc-input" rows="5" placeholder="请详细描述本次更新的变动..."></textarea>
            </div>
          </div>
          <div class="modal-btns">
            <button type="button" class="mc-btn" @click="updateLogModalActive = false; editingUpdateLog = null">取消</button>
            <button type="button" class="mc-btn mc-btn-primary" @click="saveUpdateLog">发布并记录</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 居民模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: residentModalActive }" @click.self="residentModalActive = false">
        <div class="mc-modal" :class="{ active: residentModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ editingResident ? '编辑居民' : '添加居民' }}</h3>
          <div class="mc-modal-scroll">
            <input v-model="residentForm.name" type="text" class="mc-input" placeholder="居民名称" />
            <input v-model="residentForm.title" type="text" class="mc-input" placeholder="职位/称号" />
            <div style="margin-top:10px;">
              <label style="color: #000; font-size: 12px; display: block; margin-bottom: 5px;">选择头像：</label>
              <input type="file" @change="handleResidentAvatarChange" accept="image/*" style="margin-bottom: 10px;" />
              <div v-if="residentAvatarPreview" style="margin: 10px 0;">
                <img :src="residentAvatarPreview" style="max-width: 100%; max-height: 150px; border: 2px solid #000; object-fit: contain;" />
                <button type="button" class="mc-btn" @click="uploadResidentAvatar" style="margin-top: 10px; width: 100%;">上传头像</button>
              </div>
              <div v-if="residentForm.avatarUrl && !residentAvatarPreview" style="margin: 10px 0;">
                <img :src="residentForm.avatarUrl" style="max-width: 100%; max-height: 150px; border: 2px solid #000;" />
                <div style="font-size: 10px; color: #666; margin-top: 5px;">已上传的头像</div>
              </div>
            </div>
            <input 
              v-model.number="residentForm.sortOrder" 
              type="number" 
              class="mc-input" 
              placeholder="排序顺序" 
              @blur="validateResidentSortOrder"
              style="margin-top:10px;"
            />
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeResidentModal">取消</button>
            <button class="mc-btn mc-btn-primary" @click="saveResident">保存</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 建筑模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: buildingModalActive }" @click.self="buildingModalActive = false">
        <div class="mc-modal building-modal" :class="{ active: buildingModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ editingBuilding ? '编辑建筑' : '添加建筑' }}</h3>
          <div class="mc-modal-scroll">
            <input v-model="buildingForm.name" type="text" class="mc-input" placeholder="建筑名称" />
            <input v-model="buildingForm.subtitle" type="text" class="mc-input" placeholder="副标题" />
            <div class="date-input-group">
              <div v-if="buildingForm.date !== 'unknown'" class="mc-datepicker-container">
                <input 
                  v-model="buildingForm.dateValue" 
                  type="text" 
                  class="mc-input" 
                  readonly
                  placeholder="年 / 月 / 日" 
                  @click="toggleDatePicker"
                />
                <div v-if="showDatePicker" class="mc-datepicker-panel">
                  <div class="mc-datepicker-header">
                    <button type="button" class="mc-datepicker-btn" @click="prevYear" title="上一年">&lt;&lt;</button>
                    <button type="button" class="mc-datepicker-btn" @click="prevMonth" title="上个月">&lt;</button>
                    <span class="mc-datepicker-title">{{ currentYear }}年 {{ currentMonth + 1 }}月</span>
                    <button type="button" class="mc-datepicker-btn" @click="nextMonth" title="下个月">&gt;</button>
                    <button type="button" class="mc-datepicker-btn" @click="nextYear" title="下一年">&gt;&gt;</button>
                  </div>
                  <div class="mc-datepicker-weekdays">
                    <span v-for="day in ['日','一','二','三','四','五','六']" :key="day">{{ day }}</span>
                  </div>
                  <div class="mc-datepicker-days">
                    <span 
                      v-for="empty in firstDayOfMonth" 
                      :key="'empty-'+empty" 
                      class="mc-datepicker-day empty"
                    ></span>
                    <span 
                      v-for="day in daysInMonth" 
                      :key="day" 
                      class="mc-datepicker-day"
                      :class="{ active: isSelected(day) }"
                      @click="selectDate(day)"
                    >
                      {{ day }}
                    </span>
                  </div>
                  <div class="mc-datepicker-footer">
                    <button type="button" class="mc-datepicker-footer-btn" @click="selectToday">TODAY</button>
                    <button type="button" class="mc-datepicker-footer-btn clear" @click="clearDate">CLEAR</button>
                  </div>
                </div>
              </div>
              <input 
                v-else
                type="text" 
                class="mc-input" 
                value="建成时间未知" 
                disabled
              />
              <button 
                type="button" 
                class="mc-unknown-btn" 
                :class="{ active: buildingForm.date === 'unknown' }"
                @click="buildingForm.date = (buildingForm.date === 'unknown' ? '' : 'unknown'); buildingForm.dateValue = ''; showDatePicker = false"
                title="不知道具体的建成时间？那就填未知吧~"
              >
                <span class="mc-unknown-icon">?</span>
                <span class="mc-unknown-text">未知</span>
              </button>
            </div>
            <input v-model="buildingForm.author" type="text" class="mc-input" placeholder="建筑师" />
            <div style="margin-top:10px;">
              <label style="color: #000; font-size: 12px; display: block; margin-bottom: 5px;">选择轮播图片（可多选）：</label>
              <input type="file" @change="handleBuildingImagesChange" accept="image/*" multiple style="margin-bottom: 10px;" />
              <div v-if="buildingForm.images && buildingForm.images.length > 0" class="mc-image-grid">
                <div
                  v-for="(imageUrl, index) in buildingForm.images"
                  :key="imageUrl + '-' + index"
                  class="mc-image-tile"
                  :class="{ 'mc-image-tile-cover': index === 0 }"
                  draggable="true"
                  @dragstart="handleImageDragStart($event, index)"
                  @dragover.prevent="handleImageDragOver"
                  @drop="handleImageDrop($event, index)"
                >
                  <div v-if="index === 0" class="mc-image-cover-label">封面图</div>
                  <img :src="imageUrl" class="mc-image-thumb" @click="openImagePreview(imageUrl)" />
                  <button type="button" class="mc-image-del" @click="removeBuildingImage(index)">删除</button>
                </div>
              </div>
              <div v-if="buildingUploadQueue.length > 0" class="mc-image-uploading">
                <div v-for="item in buildingUploadQueue" :key="item.id" class="mc-image-uploading-item">
                  <img :src="item.localUrl" />
                  <div class="mc-image-uploading-label">
                    <span v-if="item.status === 'uploading'">上传中...</span>
                    <span v-else-if="item.status === 'error'" style="color: #ff6b6b;">失败</span>
                    <span v-else-if="item.status === 'success'" style="color: #5ea818;">成功</span>
                  </div>
                </div>
              </div>
            </div>
            <textarea
              ref="buildingDescriptionTextarea"
              v-model="buildingForm.descriptionJson"
              class="mc-input"
              rows="5"
              placeholder="建筑描述（JSON数组，每行一个段落）"
              @input="autoGrowTextarea($event)"
              style="margin-top:10px;"
            ></textarea>
            <div class="hint" style="color: rgba(0,0,0,0.45);">{{ (buildingForm.descriptionJson || '').trim().length }}/不限制</div>
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeBuildingModal">取消</button>
            <button class="mc-btn mc-btn-primary" @click="saveBuilding">保存</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 将原因弹窗 Teleport 到 body，并赋予极高层级 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: buildingReasonModalActive }" @click.self="buildingReasonModalActive = false">
        <div class="mc-modal building-reason-modal" :class="{ active: buildingReasonModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ pendingBuildingAction === 'delete' ? '删除建筑原因' : '修改建筑原因' }}</h3>
          <div class="mc-modal-scroll">
            <div style="font-size:12px; color:#000;">原因（将异步邮件通知用户，并写入通知中心）：</div>
            <input v-model="buildingReason" type="text" class="mc-input" placeholder="请输入原因..." style="margin-top:10px;" />
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeBuildingReasonModal">取消</button>
            <button class="mc-btn mc-btn-primary" @click="confirmBuildingReason">确认</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 编年史模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: chronicleModalActive }" @click.self="chronicleModalActive = false">
        <div class="mc-modal" :class="{ active: chronicleModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ editingChronicle ? '编辑编年史' : '添加编年史' }}</h3>
          <div class="mc-modal-scroll">
            <div class="mc-datepicker-container">
              <input 
                v-model="chronicleForm.date" 
                type="text" 
                class="mc-input" 
                readonly
                placeholder="年 / 月 / 日" 
                @click="toggleDatePicker"
              />
              <div v-if="showDatePicker" class="mc-datepicker-panel">
                <!-- 原有日期选择逻辑 -->
                <div class="mc-datepicker-header">
                  <button type="button" class="mc-datepicker-btn" @click="prevYear" title="上一年">&lt;&lt;</button>
                  <button type="button" class="mc-datepicker-btn" @click="prevMonth" title="上个月">&lt;</button>
                  <span class="mc-datepicker-title">{{ currentYear }}年 {{ currentMonth + 1 }}月</span>
                  <button type="button" class="mc-datepicker-btn" @click="nextMonth" title="下个月">&gt;</button>
                  <button type="button" class="mc-datepicker-btn" @click="nextYear" title="下一年">&gt;&gt;</button>
                </div>
                <div class="mc-datepicker-weekdays">
                  <span v-for="day in ['日','一','二','三','四','五','六']" :key="day">{{ day }}</span>
                </div>
                <div class="mc-datepicker-days">
                  <span v-for="empty in firstDayOfMonth" :key="'empty-'+empty" class="mc-datepicker-day empty"></span>
                  <span v-for="day in daysInMonth" :key="day" class="mc-datepicker-day" :class="{ active: isSelected(day) }" @click="selectDate(day)">{{ day }}</span>
                </div>
                <div class="mc-datepicker-footer">
                  <button type="button" class="mc-datepicker-footer-btn" @click="selectToday">TODAY</button>
                  <button type="button" class="mc-datepicker-footer-btn clear" @click="clearDate">CLEAR</button>
                </div>
              </div>
            </div>
            <input v-model="chronicleForm.title" type="text" class="mc-input" placeholder="标题（如：创世余烬）" style="margin-top:10px;" />
            <textarea v-model="chronicleForm.content" class="mc-input" rows="5" placeholder="内容" style="margin-top:10px;"></textarea>
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeChronicleModal">取消</button>
            <button class="mc-btn mc-btn-primary" @click="saveChronicle">保存</button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- 轮播图模态框 -->
    <teleport to="body">
      <div class="mc-modal-mask" :class="{ active: carouselModalActive }" @click.self="carouselModalActive = false">
        <div class="mc-modal" :class="{ active: carouselModalActive }">
          <h3 style="color: #000; margin: 0; font-size: 14px;">{{ editingCarousel ? '编辑轮播图' : '添加轮播图' }}</h3>
          <div class="mc-modal-scroll">
            <div>
              <label style="color: #000; font-size: 12px; display: block; margin-bottom: 5px;">选择图片：</label>
              <input type="file" @change="handleCarouselFileChange" accept="image/*" style="margin-bottom: 10px;" />
              <div v-if="carouselPreview" style="margin: 10px 0;">
                <img :src="carouselPreview" style="max-width: 100%; max-height: 200px; border: 2px solid #000; object-fit: contain;" />
                <button type="button" class="mc-btn" @click="uploadCarouselImage" style="margin-top: 10px; width: 100%;">上传图片</button>
              </div>
              <div v-if="carouselForm.imageUrl && !carouselPreview" style="margin: 10px 0;">
                <img :src="carouselForm.imageUrl" style="max-width: 100%; max-height: 200px; border: 2px solid #000;" />
                <div style="font-size: 10px; color: #666; margin-top: 5px;">已上传的图片</div>
              </div>
            </div>
            <input v-model="carouselForm.title" type="text" class="mc-input" placeholder="标题（显示为：【标题】）" style="margin-top:10px;" />
            <input 
              v-model.number="carouselForm.sortOrder" 
              type="number" 
              class="mc-input" 
              placeholder="排序顺序（数字越小越靠前）" 
              @blur="validateCarouselSortOrder"
              style="margin-top:10px;"
            />
            <div style="margin-top:10px;">
              <label style="color: #000; font-size: 12px; display: flex; align-items: center; gap: 10px;">
                <input type="checkbox" v-model.number="carouselForm.isActive" :true-value="1" :false-value="0" />
                <span>启用</span>
              </label>
            </div>
          </div>
          <div class="modal-btns">
            <button class="mc-btn" @click="closeCarouselModal">取消</button>
            <button class="mc-btn mc-btn-primary" @click="saveCarousel">保存</button>
          </div>
        </div>
      </div>
    </teleport>

    <teleport to="body">
      <div id="toast" :class="{ active: toastActive }">{{ toastMessage }}</div>
    </teleport>
  </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useRouter } from 'vue-router'
import { API_BASE } from '../config/apiBase'
import { mcConfirm, mcPrompt } from '../utils/mcDialog'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import McDatepicker from '../components/McDatepicker.vue'

// API_BASE moved to @/config/apiBase


const getAdminAuthHeader = () => {
  const token = localStorage.getItem('admin_token')
  if (!token) return {}
  return { Authorization: `Bearer ${token}` }
}

export default {
  name: 'AdminPage',
  components: {
    McDatepicker
  },
  setup() {
    const router = useRouter()
    const adminMap = ref(null)
    const todayStr = new Date().toISOString().split('T')[0]
    const mapLocked = ref(false)
    const leafletMarkers = ref([])
    const toastActive = ref(false)
    const toastMessage = ref('')

    // 通用弹窗回顶逻辑
    const resetModalScroll = () => {
      nextTick(() => {
        const masks = document.querySelectorAll('.mc-modal-mask.active')
        masks.forEach((m) => { m.scrollTop = 0 })
        window.scrollTo(0, 0)
      })
    }

    // 图片全屏预览
    const imagePreviewActive = ref(false)
    const imagePreviewUrl = ref('')

    // 数据
    const notices = ref([])
    const markers = ref([])
    const residents = ref([])
    const buildings = ref([])
    const chronicles = ref([])
    const carousels = ref([])
    const users = ref([])
    const updateLogs = ref([])

    // 更新日志管理
    const updateLogModalActive = ref(false)
    const editingUpdateLog = ref(null)
    const updateLogForm = ref({
      version: '',
      updateTime: todayStr,
      content: ''
    })

    const loadUpdateLogs = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/update-logs`, {
          headers: getAdminAuthHeader()
        })
        const data = await res.json()
        if (data.code === 200) {
          // 直接回显所有数据；按版本号做一次兜底降序，防止后端排序异常导致“最新版本”取错
          const list = Array.isArray(data.data) ? data.data : []
          const parseV = (ver) => {
            const s = String(ver || '').trim()
            const parts = s.split('.').map((x) => Number(x))
            if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null
            return parts
          }
          const cmpV = (a, b) => {
            const pa = parseV(a && a.version)
            const pb = parseV(b && b.version)
            if (!pa && !pb) return 0
            if (!pa) return 1
            if (!pb) return -1
            if (pa[0] !== pb[0]) return pb[0] - pa[0]
            if (pa[1] !== pb[1]) return pb[1] - pa[1]
            return pb[2] - pa[2]
          }
          updateLogs.value = list.slice().sort(cmpV)
        }
      } catch (e) {
        showToast('加载更新日志失败')
      }
    }

    const openUpdateLogModal = (log) => {
      if (log) {
        editingUpdateLog.value = log
        updateLogForm.value = { ...log }
      } else {
        editingUpdateLog.value = null
        // 默认版本号逻辑：上一个版本尾数+1
        let nextVersion = '1.0.0'
        if (updateLogs.value.length > 0) {
          const lastV = updateLogs.value[0].version // 已按时间降序排
          const p = lastV.split('.').map(Number)
          p[2] += 1
          nextVersion = p.join('.')
        }
        updateLogForm.value = {
          version: nextVersion,
          updateTime: todayStr,
          content: ''
        }
      }
      updateLogModalActive.value = true
      resetModalScroll()
    }

    const closeUpdateLogModal = () => {
      updateLogModalActive.value = false
      editingUpdateLog.value = null
    }

    const validateVersion = (isSubmit = false) => {
      const v = updateLogForm.value.version.trim()
      
      if (!/^\d+\.\d+\.\d+$/.test(v)) {
        showToast('版本号格式有误！应为 x.y.z')
        return false
      }

      // 如果只是失焦校验且格式正确，则不再向下进行严格递增校验
      if (!isSubmit) return true
      
      // 过滤出除了正在编辑的项之外的所有有效日志
      const otherLogs = updateLogs.value.filter(l => !editingUpdateLog.value || l.id !== editingUpdateLog.value.id)
      
      // 第一个版本校验：如果没有其他日志，当前必须是 1.0.0
      if (otherLogs.length === 0) {
        if (v !== '1.0.0') {
          showToast('版本号新增逻辑有误！请仔细核对')
          return false
        }
        return true
      }

      // 获取对比基准版本（最新的一条）
      const prevLog = otherLogs[0]

      if (prevLog) {
        const p = prevLog.version.split('.').map(Number)
        const n = v.split('.').map(Number)
        
        // 允许当前版本号大于上一个版本号，且符合递增逻辑
        const isPatchInc = (n[0] === p[0] && n[1] === p[1] && n[2] === p[2] + 1)
        const isMinorInc = (n[0] === p[0] && n[1] === p[1] + 1 && n[2] === 0)
        const isMajorInc = (n[0] === p[0] + 1 && n[1] === 0 && n[2] === 0)

        // 如果是编辑模式且版本号没变，允许通过
        if (editingUpdateLog.value && v === editingUpdateLog.value.version) {
          return true
        }

        if (!isPatchInc && !isMinorInc && !isMajorInc) {
          showToast('版本号新增逻辑有误！请仔细核对')
          return false
        }
      }
      return true
    }

    const saveUpdateLog = async () => {
      if (!validateVersion(true)) return
      if (!updateLogForm.value.content.trim()) {
        showToast('请输入更新内容')
        return
      }

      const isEdit = !!editingUpdateLog.value
      const url = isEdit ? `${API_BASE}/api/update-logs/${editingUpdateLog.value.id}` : `${API_BASE}/api/update-logs`
      const method = isEdit ? 'PUT' : 'POST'

      try {
        const res = await fetch(url, {
          method,
          headers: { ...getAdminAuthHeader(), 'Content-Type': 'application/json' },
          body: JSON.stringify(updateLogForm.value)
        })
        const data = await res.json()
        if (data.code === 200 || data.success) {
          showToast(isEdit ? '已同步历史档案' : '新版本已发布')
          await loadUpdateLogs()
          closeUpdateLogModal()
        } else {
          showToast(data.msg || data.message || '保存失败')
        }
      } catch (e) {
        showToast('保存失败，请检查网络')
      }
    }

    const deleteUpdateLog = async (id) => {
      const ok = await mcConfirm('确定要抹除这段历史记录吗？不可恢复！', { title: '确认操作' })
      if (!ok) return
      try {
        const res = await fetch(`${API_BASE}/api/update-logs/${id}`, {
          method: 'DELETE',
          headers: getAdminAuthHeader()
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('记录已抹除')
          loadUpdateLogs()
        }
      } catch (e) {
        showToast('抹除失败')
      }
    }

    // 邮件管理
    const TAB_STORAGE_KEY = 'admin.activeTab'
    const VALID_TABS = new Set(['main', 'mail', 'updateLog', 'traffic'])

    const getInitialTab = () => {
      try {
        const url = new URL(window.location.href)
        const fromQuery = url.searchParams.get('tab')
        if (fromQuery && VALID_TABS.has(fromQuery)) return fromQuery
      } catch (e) {
        // ignore
      }
      try {
        const saved = localStorage.getItem(TAB_STORAGE_KEY)
        if (saved && VALID_TABS.has(saved)) return saved
      } catch (e) {
        // ignore
      }
      return 'main'
    }

    const activeTab = ref(getInitialTab())

    // 流量监控
    const trafficPeriod = ref('today')
    const trafficPeriods = ref([
      { label: '今日', value: 'today' },
      { label: '本月', value: 'month' },
      { label: '本年', value: 'year' },
      { label: '以往', value: 'all' }
    ])
    const trafficStats = ref([])
    const trafficMapRef = ref(null)
    let trafficChart = null

    // WebSocket 实时流量更新
    const trafficWs = ref(null)
    let trafficWsRefreshTimer = null
    let trafficWsReconnectTimer = null

    const closeTrafficWs = () => {
      if (trafficWs.value) {
        trafficWs.value.onclose = null // 移除监听，防止触发重连
        trafficWs.value.close()
        trafficWs.value = null
      }
      if (trafficWsReconnectTimer) {
        clearTimeout(trafficWsReconnectTimer)
        trafficWsReconnectTimer = null
      }
      if (trafficWsRefreshTimer) {
        clearTimeout(trafficWsRefreshTimer)
        trafficWsRefreshTimer = null
      }
    }

    const connectTrafficWs = () => {
      if (activeTab.value !== 'traffic' || trafficWs.value) return

      try {
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
        // 如果是开发环境（localhost），通常后端在 8080；如果是生产环境，则用当前 host
        const host = window.location.host
        const wsUrl = `${protocol}//${host}/ws/admin/traffic`
        
        const ws = new WebSocket(wsUrl)
        trafficWs.value = ws

        ws.onopen = () => {
          // 发送鉴权
          const token = localStorage.getItem('admin_token')
          ws.send(JSON.stringify({ type: 'auth', token }))
        }

        ws.onmessage = (e) => {
          try {
            const data = JSON.parse(e.data)
            if (data.type === 'traffic_event') {
              // 收到访问事件，节流刷新
              if (trafficWsRefreshTimer) clearTimeout(trafficWsRefreshTimer)
              trafficWsRefreshTimer = setTimeout(() => {
                if (activeTab.value === 'traffic') {
                  loadTrafficStats()
                }
              }, 800)
            }
          } catch (err) {
            // ignore
          }
        }

        ws.onclose = () => {
          trafficWs.value = null
          // 3秒后尝试重连
          if (activeTab.value === 'traffic') {
            trafficWsReconnectTimer = setTimeout(connectTrafficWs, 3000)
          }
        }

        ws.onerror = () => {
          ws.close()
        }
      } catch (err) {
        // ignore
      }
    }

    const mailList = ref([])
    const unreadMailCount = ref(0)
    const mailBatchMode = ref(false)
    const selectedMailIds = ref(new Set())
    const toggleMailBatchMode = () => {
      mailBatchMode.value = !mailBatchMode.value
      if (!mailBatchMode.value) {
        selectedMailIds.value.clear()
      }
    }

    const isMailSelectable = (mail) => {
      return mail && Number(mail.status) !== 0
    }

    const toggleMailSelection = (mail) => {
      if (!isMailSelectable(mail)) {
        showToast('未读信件不可删除')
        return
      }
      if (selectedMailIds.value.has(mail.id)) {
        selectedMailIds.value.delete(mail.id)
      } else {
        selectedMailIds.value.add(mail.id)
      }
    }


    const selectedMailCount = computed(() => selectedMailIds.value.size)

    const replyModalActive = ref(false)
    const replyTarget = ref(null)
    const replyContent = ref('')

    // 邮件筛选/排序
    const mailSearch = ref('')
    const mailTypeFilter = ref('all')
    const mailUnreadOnly = ref(false)
    const mailSort = ref('new')

    const normalizeMailType = (type) => {
      const t = String(type || '').trim()
      const lower = t.toLowerCase()
      if (['bug', 'issue', 'error'].includes(lower)) return 'bug'
      if (['report', '举报', 'complaint'].includes(lower) || t.includes('举报')) return 'report'
      if (['suggest', '建议', 'proposal'].includes(lower) || t.includes('建议')) return 'suggest'
      if (['feedback', '反馈', 'build', 'normal', 'other'].includes(lower) || t.includes('反馈')) return 'feedback'
      return 'other'
    }

    const getMailTypeLabel = (type) => {
      const key = normalizeMailType(type)
      if (key === 'bug') return 'Bug/故障'
      if (key === 'report') return '举报/投诉'
      if (key === 'suggest') return '建议'
      if (key === 'feedback') return '反馈'
      return '其它'
    }

    const mailTypeOptions = computed(() => {
      const set = new Set()
      ;(mailList.value || []).forEach((m) => {
        if (m && m.type != null) set.add(normalizeMailType(m.type))
      })
      const keys = Array.from(set)
      const order = ['feedback', 'suggest', 'report', 'bug', 'other']
      keys.sort((a, b) => order.indexOf(a) - order.indexOf(b))
      return keys.map((k) => ({ key: k, label: getMailTypeLabel(k) }))
    })

    const filteredMailList = computed(() => {
      const q = (mailSearch.value || '').trim().toLowerCase()
      const type = mailTypeFilter.value
      const unreadOnly = !!mailUnreadOnly.value
      const sort = mailSort.value

      let list = Array.isArray(mailList.value) ? mailList.value.slice() : []

      if (type && type !== 'all') {
        list = list.filter((m) => normalizeMailType(m.type) === type)
      }

      if (unreadOnly) {
        list = list.filter((m) => Number(m.status) === 0)
      }

      if (q) {
        list = list.filter((m) => {
          const nickname = String(m.nickname || '').toLowerCase()
          const content = String(m.content || '').toLowerCase()
          const email = String(m.email || '').toLowerCase()
          return nickname.includes(q) || content.includes(q) || email.includes(q)
        })
      }

      list.sort((a, b) => {
        const ta = new Date(a.createTime || 0).getTime()
        const tb = new Date(b.createTime || 0).getTime()
        return sort === 'old' ? (ta - tb) : (tb - ta)
      })

      return list
    })

    // 邮件详情查看
    const mailDetailModalActive = ref(false)
    const selectedMail = ref(null)

    const currentMailIndex = computed(() => {
      if (!selectedMail.value) return -1
      return filteredMailList.value.findIndex(m => m.id === selectedMail.value.id)
    })

    const handleMailKeydown = (e) => {
      if (!mailDetailModalActive.value) return
      if (e.key === 'Escape') closeMailDetail()
    }

    const openMailDetail = (mail) => {
      selectedMail.value = mail
      mailDetailModalActive.value = true
      window.addEventListener('keydown', handleMailKeydown)
    }

    const closeMailDetail = () => {
      mailDetailModalActive.value = false
      selectedMail.value = null
      window.removeEventListener('keydown', handleMailKeydown)
    }

    const loadMailList = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/mail/list`, {
          headers: getAdminAuthHeader()
        })
        const data = await res.json()
        if (data.code === 200) {
          mailList.value = data.data
        }
      } catch (e) {
        showToast('加载邮件列表失败')
      }
    }

    const refreshUnreadMailCount = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/mail/unread-count`)
        const data = await res.json()
        if (data.code === 200) {
          unreadMailCount.value = data.data.count
        }
      } catch (e) { /* ignore */ }
    }

    const confirmBatchDelete = async () => {
      if (selectedMailIds.value.size === 0) return
      
      const ok = await mcConfirm(`确定要销毁这 ${selectedMailIds.value.size} 封信件吗？(不可恢复)`)
      if (!ok) return

      try {
        const res = await fetch(`${API_BASE}/api/admin/mail/batch-delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify({
            ids: Array.from(selectedMailIds.value)
          })
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast(`成功销毁 ${data.data.deleted} 封信件`)
          mailBatchMode.value = false
          selectedMailIds.value.clear()
          loadMailList()
          refreshUnreadMailCount()
        } else {
          showToast(data.message || '删除失败')
        }
      } catch (e) {
        showToast('网络错误')
      }
    }

    const deleteSingleMail = async (id) => {
      const ok = await mcConfirm('确定要销毁这封信件吗？')
      if (!ok) return
      try {
        const res = await fetch(`${API_BASE}/api/admin/mail/delete/${id}`, {
          method: 'POST',
          headers: getAdminAuthHeader()
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('信件已销毁')
          loadMailList()
          refreshUnreadMailCount()
        } else {
          showToast(data.message || '删除失败')
        }
      } catch (e) {
        showToast('操作失败')
      }
    }

    const markMailRead = async (id) => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/mail/mark-read/${id}`, {
          method: 'POST',
          headers: getAdminAuthHeader()
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('已标记为已阅')
          loadMailList()
          refreshUnreadMailCount()
        }
      } catch (e) {
        showToast('操作失败')
      }
    }

    const openReplyModal = (mail) => {
      replyTarget.value = mail
      replyContent.value = ''
      replyModalActive.value = true
      resetModalScroll()
    }

    const closeReplyModal = () => {
      replyModalActive.value = false
      replyTarget.value = null
      replyContent.value = ''
    }

    const sendReply = async () => {
      if (!replyContent.value.trim()) {
        showToast('请输入回复内容')
        return
      }
      try {
        const res = await fetch(`${API_BASE}/api/admin/mail/reply`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify({
            id: replyTarget.value.id,
            replyContent: replyContent.value.trim()
          })
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('回复成功')
          closeReplyModal()
          loadMailList()
          refreshUnreadMailCount()
        } else {
          showToast(data.message || '回复失败')
        }
      } catch (e) {
        showToast('网络错误')
      }
    }

    watch(activeTab, (newTab) => {
      if (newTab === 'mail') {
        loadMailList()
      } else if (newTab === 'updateLog') {
        loadUpdateLogs()
      }
    })

    // 模态框状态
    const noticeModalActive = ref(false)
    const markerModalActive = ref(false)
    const residentModalActive = ref(false)
    const buildingModalActive = ref(false)
    const chronicleModalActive = ref(false)
    const carouselModalActive = ref(false)
    const disableModalActive = ref(false)

    // 用户公告管理
    const userNotices = ref([])
    const userNoticeModalActive = ref(false)
    const editingUserNotice = ref(null)
    const userNoticeForm = ref({ content: '', reason: '' })
    const originalUserNoticeForm = ref(null)

    const formatDateTime = (iso) => {
      if (!iso) return '-'
      try {
        return String(iso).replace('T', ' ').substring(0, 16)
      } catch (e) {
        return String(iso)
      }
    }

    const openUserNoticeModal = (notice) => {
      editingUserNotice.value = notice
      userNoticeForm.value = { content: notice && notice.content ? notice.content : '', reason: '' }
      originalUserNoticeForm.value = JSON.parse(JSON.stringify(userNoticeForm.value))
      userNoticeModalActive.value = true
      resetModalScroll()
    }

    const closeUserNoticeModal = () => {
      userNoticeModalActive.value = false
      editingUserNotice.value = null
      userNoticeForm.value = { content: '', reason: '' }
    }

    const saveUserNotice = async () => {
      if (!editingUserNotice.value) return
      const content = (userNoticeForm.value && userNoticeForm.value.content ? String(userNoticeForm.value.content) : '').trim()
      const reason = (userNoticeForm.value && userNoticeForm.value.reason ? String(userNoticeForm.value.reason) : '').trim()
      if (!content) {
        showToast('请输入公告内容')
        return
      }
      if (content.length > 100) {
        showToast('公告内容最多100字')
        return
      }
      if (!reason) {
        showToast('请填写修改原因')
        return
      }

      // 检查是否有修改（仅对比content）
      if (originalUserNoticeForm.value && String(originalUserNoticeForm.value.content || '') === content) {
        showToast('未修改任何内容')
        closeUserNoticeModal()
        return
      }

      try {
        const res = await fetch(`${API_BASE}/api/admin/user-notices/${editingUserNotice.value.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify({ content, reason })
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('更新成功')
          closeUserNoticeModal()
          loadData()
        } else {
          showToast(data.message || '更新失败')
        }
      } catch (e) {
        showToast('更新失败')
      }
    }

    const adminDeleteUserNotice = async (id) => {
      const reason = (await mcPrompt('请输入删除原因（必填）', ''))
      if (reason === null) return
      if (!String(reason).trim()) {
        showToast('请填写删除原因')
        return
      }
      if (!(await mcConfirm('确定要删除这条用户公告吗？'))) return
      try {
        const res = await fetch(`${API_BASE}/api/admin/user-notices/${id}`, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify({ reason: String(reason).trim() })
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('删除成功')
          loadData()
        } else {
          showToast(data.message || '删除失败')
        }
      } catch (e) {
        showToast('删除失败')
      }
    }

    // 编辑状态
    const editingNotice = ref(null)
    const editingMarker = ref(null)
    const editingResident = ref(null)
    const editingBuilding = ref(null)
    const editingChronicle = ref(null)
    const editingCarousel = ref(null)

    const originalNoticeForm = ref(null)
    const originalMarkerForm = ref(null)
    const originalResidentForm = ref(null)
    const originalBuildingForm = ref(null)
    const originalChronicleForm = ref(null)
    const originalCarouselForm = ref(null)

    // --- 自定义像素风日历逻辑开始 ---
    const showDatePicker = ref(false)
    const currentYear = ref(new Date().getFullYear())
    const currentMonth = ref(new Date().getMonth())

    const toggleDatePicker = () => {
      showDatePicker.value = !showDatePicker.value
      let dateVal = ''
      if (buildingModalActive.value) {
        dateVal = buildingForm.value.dateValue
      } else if (chronicleModalActive.value) {
        dateVal = chronicleForm.value.date
      }

      if (dateVal) {
        const d = new Date(dateVal)
        if (!isNaN(d.getTime())) {
          currentYear.value = d.getFullYear()
          currentMonth.value = d.getMonth()
        }
      }
    }

    const prevYear = () => {
      currentYear.value--
    }

    const nextYear = () => {
      currentYear.value++
    }

    const prevMonth = () => {
      if (currentMonth.value === 0) {
        currentYear.value--
        currentMonth.value = 11
      } else {
        currentMonth.value--
      }
    }

    const nextMonth = () => {
      if (currentMonth.value === 11) {
        currentYear.value++
        currentMonth.value = 0
      } else {
        currentMonth.value++
      }
    }

    const daysInMonth = computed(() => {
      return new Date(currentYear.value, currentMonth.value + 1, 0).getDate()
    })

    const firstDayOfMonth = computed(() => {
      return new Date(currentYear.value, currentMonth.value, 1).getDay()
    })

    const isSelected = (day) => {
      let dateVal = ''
      if (buildingModalActive.value) {
        dateVal = buildingForm.value.dateValue
      } else if (chronicleModalActive.value) {
        dateVal = chronicleForm.value.date
      }
      if (!dateVal) return false
      const d = new Date(dateVal)
      return d.getFullYear() === currentYear.value && 
             d.getMonth() === currentMonth.value && 
             d.getDate() === day
    }

    const selectDate = (day) => {
      const y = currentYear.value
      const m = String(currentMonth.value + 1).padStart(2, '0')
      const d = String(day).padStart(2, '0')
      const formattedDate = `${y}-${m}-${d}`
      
      if (buildingModalActive.value) {
        buildingForm.value.dateValue = formattedDate
        buildingForm.value.date = 'date'
      } else if (chronicleModalActive.value) {
        chronicleForm.value.date = formattedDate
      }
      showDatePicker.value = false
    }

    const selectToday = () => {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      const formattedDate = `${y}-${m}-${d}`
      
      if (buildingModalActive.value) {
        buildingForm.value.dateValue = formattedDate
        buildingForm.value.date = 'date'
      } else if (chronicleModalActive.value) {
        chronicleForm.value.date = formattedDate
      }
      showDatePicker.value = false
    }

    const clearDate = () => {
      if (buildingModalActive.value) {
        buildingForm.value.dateValue = ''
        buildingForm.value.date = ''
      } else if (chronicleModalActive.value) {
        chronicleForm.value.date = ''
      }
      showDatePicker.value = false
    }
    // --- 自定义像素风日历逻辑结束 ---

    const disableTarget = ref(null)
    const disableReason = ref('')

    // 表单数据
    const noticeForm = ref({ content: '', type: 'normal' })
    const markerForm = ref({ name: '', lat: 0, lng: 0 })
    const residentForm = ref({ name: '', title: '', avatarUrl: '', sortOrder: 0 })
    const buildingForm = ref({
      name: '',
      subtitle: '',
      date: '',
      dateValue: '',
      author: '',
      coverImage: '',
      images: [],
      imagesJson: '',
      descriptionJson: '',
      sortOrder: 0
    })

    

    const buildingReasonModalActive = ref(false)
    const buildingReason = ref('')
    const pendingBuildingAction = ref(null) // 'update' | 'delete'
    const pendingBuildingId = ref(null)
    const pendingBuildingData = ref(null)
    const chronicleForm = ref({ date: '', title: '', content: '', sortOrder: 0 })
    const carouselForm = ref({ imageUrl: '', title: '', sortOrder: 0, isActive: 1 })
    const uploadFile = ref(null)
    const carouselPreview = ref(null)
    const buildingCoverPreview = ref(null)
    const buildingImagesPreviews = ref([])
    const residentAvatarPreview = ref(null)

    const buildingDescriptionTextarea = ref(null)

    const autoGrowTextarea = (e) => {
      const el = e && e.target ? e.target : null
      if (!el) return
      el.style.height = 'auto'
      el.style.height = `${el.scrollHeight}px`
    }

    const syncBuildingDescriptionTextareaHeight = () => {
      const el = buildingDescriptionTextarea.value
      if (!el) return
      el.style.height = 'auto'
      el.style.height = `${el.scrollHeight}px`
    }

    const mapFileInput = ref(null)
    const mapUploadFile = ref(null)
    const mapImageUrl = ref('')
    const mapUploadModalActive = ref(false)
    const mapUploadPreview = ref(null)
    let mapImageOverlay = null

    const showToast = (message) => {
      toastMessage.value = message
      toastActive.value = true
      setTimeout(() => {
        toastActive.value = false
      }, 3000)
    }

    const isUserPublishedBuilding = (b) => {
      if (!b) return false
      const u = b.userId
      return u != null && String(u).trim() !== '' && String(u) !== '0'
    }

    const openImagePreview = (url) => {
      if (!url) return
      imagePreviewUrl.value = url
      // 下一帧再添加 active 类，确保初始状态被应用
      requestAnimationFrame(() => {
        imagePreviewActive.value = true
      })
    }

    const closeImagePreview = () => {
      imagePreviewActive.value = false
      // 等待动画结束后再清空 URL
      setTimeout(() => {
        imagePreviewUrl.value = ''
      }, 300)
    }

    const onGlobalKeydown = (e) => {
      if (e.key === 'Escape' && imagePreviewActive.value) {
        closeImagePreview()
      }
    }

    const goHome = () => {
      router.push('/index')
    }

    const logoutAdmin = async () => {
      if (!(await mcConfirm('确定要退出登录吗？'))) return
      localStorage.removeItem('admin_token')
      router.push('/admin')
    }

    const goBuildingDetail = (building) => {
      if (!building || building.id == null) return
      router.push({
        path: `/building/${building.id}`,
        query: { from: 'set' }
      })
    }

    const getTypeName = (type) => {
      const map = { top: '置顶', security: '安全', infrastructure: '基建', normal: '普通' }
      return map[type] || type || '普通'
    }

    // 加载数据
    const parseDate = (d)=> {
        if(!d) return Number.MAX_SAFE_INTEGER;
        return new Date(d.replace(/\./g,'-')).getTime();
      };

    const validateResidentSortOrder = () => {
      const count = residents.value.length
      const max = editingResident.value ? count : count + 1
      let val = residentForm.value.sortOrder
      if (val <= 0) val = 1
      if (val > max) val = max
      residentForm.value.sortOrder = val
    }

    const validateCarouselSortOrder = () => {
      const count = carousels.value.length
      const max = editingCarousel.value ? count : count + 1
      let val = carouselForm.value.sortOrder
      if (val <= 0) val = 1
      if (val > max) val = max
      carouselForm.value.sortOrder = val
    }

    const loadData = async () => {
      try {
        // 加载公告
        const noticesRes = await fetch(`${API_BASE}/api/admin/notices`, { headers: { ...getAdminAuthHeader() } })
        const noticesData = await noticesRes.json()
        if (noticesData.code === 200) {
          // 排序逻辑与首页保持一致：置顶(top)权重最高，自定义类型权重第二，其他按原逻辑
          const priority = { top: 3, normal: 0, security: 1, infrastructure: 1 }
          notices.value = (noticesData.data || []).slice().sort((a, b) => {
            const weightA = priority[a.type] !== undefined ? priority[a.type] : 2
            const weightB = priority[b.type] !== undefined ? priority[b.type] : 2
            return weightB - weightA
          })
        }

        // 加载标点
        const markersRes = await fetch(`${API_BASE}/api/admin/markers`, { headers: { ...getAdminAuthHeader() } })
        const markersData = await markersRes.json()
        if (markersData.code === 200) {
          markers.value = markersData.data
        }

        // 加载居民
        const residentsRes = await fetch(`${API_BASE}/api/admin/residents`, { headers: { ...getAdminAuthHeader() } })
        const residentsData = await residentsRes.json()
        if (residentsData.code === 200) {
          residents.value = residentsData.data
        }

        // 加载建筑
        const buildingsRes = await fetch(`${API_BASE}/api/admin/buildings`, { headers: { ...getAdminAuthHeader() } })
        const buildingsData = await buildingsRes.json()
        if (buildingsData.code === 200) {
          buildings.value = (buildingsData.data || []).slice().sort((a, b) => parseDate(a.date) - parseDate(b.date))
        }

        // 加载编年史
        const chroniclesRes = await fetch(`${API_BASE}/api/admin/chronicles`, { headers: { ...getAdminAuthHeader() } })
        const chroniclesData = await chroniclesRes.json()
        if (chroniclesData.code === 200) {
          chronicles.value = (chroniclesData.data || []).slice().sort((a,b)=> parseDate(a.date) - parseDate(b.date))
        }

        // 加载用户
        const usersRes = await fetch(`${API_BASE}/api/admin/users`, { headers: { ...getAdminAuthHeader() } })
        const usersData = await usersRes.json()
        if (usersData.code === 200) {
          users.value = usersData.data
        }

        // 加载用户公告
        const userNoticesRes = await fetch(`${API_BASE}/api/admin/user-notices`, { headers: { ...getAdminAuthHeader() } })
        const userNoticesData = await userNoticesRes.json()
        if (userNoticesData.code === 200) {
          userNotices.value = userNoticesData.data
        }

        const carouselsRes = await fetch(`${API_BASE}/api/admin/carousels`, { headers: { ...getAdminAuthHeader() } })
        const carouselsData = await carouselsRes.json()
        if (carouselsData.code === 200) {
          carousels.value = carouselsData.data
        }

        // 加载更新日志（用于 /set 页面“更新日志”标签）
        await loadUpdateLogs()
      } catch (error) {
        console.error('加载数据失败:', error)
        showToast('加载数据失败')
      }
    }

    // ========== User Management ==========
    const approveUser = async (id) => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/users/${id}/approve`, {
          method: 'PUT',
          headers: { ...getAdminAuthHeader() }
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast(data.message || '审批通过')
          loadData()
        } else {
          showToast(data.message || '操作失败')
        }
      } catch (error) {
        showToast('操作失败')
      }
    }

    const rejectModalActive = ref(false)
    const rejectTarget = ref(null)
    const rejectReason = ref('')

    const openRejectModal = (user) => {
      rejectTarget.value = user || null
      rejectReason.value = ''
      rejectModalActive.value = true
      resetModalScroll()
    }

    const closeRejectModal = () => {
      rejectModalActive.value = false
      rejectTarget.value = null
      rejectReason.value = ''
    }

    const confirmRejectUser = async () => {
      if (!rejectTarget.value || !rejectTarget.value.id) return
      if (!rejectReason.value || !String(rejectReason.value).trim()) {
        showToast('请填写拒绝理由')
        return
      }

      try {
        const res = await fetch(`${API_BASE}/api/admin/users/${rejectTarget.value.id}/reject`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify({ reason: String(rejectReason.value).trim() })
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast(data.message || '已拒绝')
          closeRejectModal()
          loadData()
        } else {
          showToast(data.message || '操作失败')
        }
      } catch (error) {
        showToast('操作失败')
      }
    }

    const enableUser = async (id) => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/users/${id}/enable`, {
          method: 'PUT',
          headers: { ...getAdminAuthHeader() }
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('已启用')
          loadData()
        } else {
          showToast(data.message || '操作失败')
        }
      } catch (error) {
        showToast('操作失败')
      }
    }

    const openDisableModal = (user) => {
      disableTarget.value = user
      disableReason.value = ''
      disableModalActive.value = true
      resetModalScroll()
    }

    const closeDisableModal = () => {
      disableModalActive.value = false
      disableTarget.value = null
      disableReason.value = ''
    }

    const confirmDisableUser = async () => {
      if (!disableTarget.value) return
      const id = disableTarget.value.id
      try {
        const res = await fetch(`${API_BASE}/api/admin/users/${id}/disable`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify({ reason: disableReason.value || '该账号已被封禁！请联系小葱咨询原因~' })
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('已禁用并踢下线')
          closeDisableModal()
          loadData()
        } else {
          showToast(data.message || '操作失败')
        }
      } catch (error) {
        showToast('操作失败')
      }
    }

    // 公告管理
    const openNoticeModal = (notice) => {
      editingNotice.value = notice
      if (notice) {
        // 判断是否是预设类型
        const isPreset = ['top', 'security', 'infrastructure', 'normal'].includes(notice.type)
        noticeForm.value = { 
          content: notice.content, 
          type: isPreset ? notice.type : 'custom',
          customType: isPreset ? '' : notice.type
        }
      } else {
        noticeForm.value = { content: '', type: 'normal', customType: '' }
      }
      originalNoticeForm.value = JSON.parse(JSON.stringify(noticeForm.value))
      noticeModalActive.value = true
      resetModalScroll()
    }

    const closeNoticeModal = () => {
      noticeModalActive.value = false
      editingNotice.value = null
    }

    const saveNotice = async () => {
      if (!noticeForm.value.content.trim()) {
        showToast('请输入公告内容')
        return
      }

      // 如果是自定义类型，校验输入
      if (noticeForm.value.type === 'custom' && !noticeForm.value.customType.trim()) {
        showToast('请输入自定义类型名称')
        return
      }

      // 新增时不做“未修改”判断；编辑时如果没有变化则不提交
      if (editingNotice.value && JSON.stringify(noticeForm.value) === JSON.stringify(originalNoticeForm.value)) {
        showToast('未修改任何内容')
        closeNoticeModal()
        return
      }

      try {
        const url = editingNotice.value
          ? `${API_BASE}/api/admin/notices/${editingNotice.value.id}`
          : `${API_BASE}/api/admin/notices`
        const method = editingNotice.value ? 'PUT' : 'POST'
        
        // 最终提交的类型：如果是 custom，则使用 customType 的值
        const finalType = noticeForm.value.type === 'custom' 
          ? noticeForm.value.customType.trim() 
          : noticeForm.value.type

        const res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify({
            content: noticeForm.value.content,
            type: finalType
          })
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('保存成功')
          closeNoticeModal()
          loadData()
        } else {
          showToast(data.message || '保存失败')
        }
      } catch (error) {
        showToast('保存失败')
      }
    }

    const deleteNotice = async (id) => {
      if (!(await mcConfirm('确定要删除这条公告吗？'))) return
      try {
        const res = await fetch(`${API_BASE}/api/admin/notices/${id}`, { 
  method: 'DELETE',
  headers: { ...getAdminAuthHeader() }
})
        const data = await res.json()
        if (data.code === 200) {
          showToast('删除成功')
          loadData()
        } else {
          const msg = String(data && data.message ? data.message : '')
          if (data && (data.code === 404 || msg.includes('不存在') || msg.includes('not exist') || msg.includes('not found'))) {
            showToast('该公告不存在！')
            loadData()
          } else {
            showToast('删除失败')
          }
        }
      } catch (error) {
        showToast('删除失败')
      }
    }

    // 标点管理
    const openMarkerModal = (marker) => {
      // 只有携带 id 的才算“编辑”，否则一律当作“新增”（比如右键地图空白处传入的临时对象）
      if (marker && marker.id != null) {
        editingMarker.value = marker
        markerForm.value = { name: marker.name, lat: marker.lat, lng: marker.lng }
      } else {
        editingMarker.value = null
        markerForm.value = {
          name: '',
          lat: marker && marker.lat != null ? marker.lat : 0,
          lng: marker && marker.lng != null ? marker.lng : 0
        }
      }
      originalMarkerForm.value = JSON.parse(JSON.stringify(markerForm.value))
      markerModalActive.value = true
      resetModalScroll()
    }

    const closeMarkerModal = () => {
      markerModalActive.value = false
      editingMarker.value = null
    }

    const saveMarker = async () => {
      if (!markerForm.value.name.trim()) {
        showToast('请输入标点名称')
        return
      }

      // 新增时不做“未修改”判断；编辑时如果没有变化则不提交
      if (editingMarker.value && JSON.stringify(markerForm.value) === JSON.stringify(originalMarkerForm.value)) {
        showToast('未修改任何内容')
        closeMarkerModal()
        return
      }

      try {
        const url = editingMarker.value
          ? `${API_BASE}/api/admin/markers/${editingMarker.value.id}`
          : `${API_BASE}/api/admin/markers`
        const method = editingMarker.value ? 'PUT' : 'POST'
        const res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify(markerForm.value)
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('保存成功')

          // 立即回显：本地更新 markers 并刷新 Leaflet marker，无需等待再次拉取
          if (editingMarker.value && editingMarker.value.id != null) {
            const idx = markers.value.findIndex((m) => m.id === editingMarker.value.id)
            if (idx !== -1) {
              markers.value[idx] = { ...markers.value[idx], ...markerForm.value }
            }
          } else {
            // 新增：优先使用后端返回的对象（含 id），否则退化为重新拉取
            if (data.data && data.data.id != null) {
              markers.value.push(data.data)
            } else {
              await loadData()
            }
          }

          updateMapMarkers()
          closeMarkerModal()
        } else {
          showToast(data.message || '保存失败')
        }
      } catch (error) {
        showToast('保存失败')
      }
    }

    const deleteMarker = async (id) => {
      if (!(await mcConfirm('确定要删除这个标点吗？'))) return
      try {
        const res = await fetch(`${API_BASE}/api/admin/markers/${id}`, {
          method: 'DELETE',
          headers: { ...getAdminAuthHeader() }
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('删除成功')
          loadData()
        } else {
          const msg = String(data && data.message ? data.message : '')
          if (data && (data.code === 404 || msg.includes('不存在') || msg.includes('not exist') || msg.includes('not found'))) {
            showToast('该标点不存在！')
            loadData()
          } else {
            showToast('删除失败')
          }
        }
      } catch (error) {
        showToast('删除失败')
      }
    }

    const updateMapMarkers = () => {
      if (!adminMap.value) return

      // 清理旧 marker（用 remove() 让 Leaflet 正确清理内部状态）
      if (leafletMarkers.value.length > 0) {
        leafletMarkers.value.forEach((m) => m && m.remove())
        leafletMarkers.value = []
      }

      markers.value.forEach((markerData) => {
        const getBanner = (l) =>
          L.divIcon({
            className: 'mc-banner-marker',
            html: `<div class="mc-banner-flag"></div><div class="mc-banner-text">${l}</div>`,
            iconSize: [0, 0]
          })

        // 重要：marker 始终 draggable=true，实际是否可拖由 dragging.enable/disable 控制
        const leafletMarker = L.marker([markerData.lat, markerData.lng], {
          icon: getBanner(markerData.name),
          draggable: true
        }).addTo(adminMap.value)

        // 初始状态：根据 mapLocked 决定是否允许拖动标点
        if (leafletMarker.dragging) {
          if (mapLocked.value) {
            leafletMarker.dragging.enable()
          } else {
            leafletMarker.dragging.disable()
          }
        }

        // 直接在 Marker 的 DOM 元素上绑定原生 contextmenu 事件，确保触发
        const iconElement = leafletMarker.getElement();
        if (iconElement) {
          iconElement.addEventListener('contextmenu', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // 调试信息，确认事件已触发
            console.log('Right-clicked on marker:', markerData.name);
            showToast(`右键点击了: ${markerData.name}`);

            openMarkerModal(markerData);
          });
        }

        leafletMarker.on('dragstart', () => {
          // 拖动标点时保证地图不可拖
          if (adminMap.value) adminMap.value.dragging.disable()
        })

        leafletMarker.on('dragend', async (e) => {
          // 拖拽结束后根据模式恢复地图拖拽能力
          if (adminMap.value) {
            if (mapLocked.value) {
              adminMap.value.dragging.disable()
            } else {
              adminMap.value.dragging.enable()
            }
          }

          const newLatLng = e.target.getLatLng()
          const oldLatLng = { lat: markerData.lat, lng: markerData.lng }

          if (newLatLng.lat === oldLatLng.lat && newLatLng.lng === oldLatLng.lng) {
            return
          }

          try {
            const res = await fetch(`${API_BASE}/api/admin/markers/${markerData.id}`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
              body: JSON.stringify({ name: markerData.name, lat: newLatLng.lat, lng: newLatLng.lng })
            })
            const data = await res.json()
            if (data.code === 200) {
              markerData.lat = newLatLng.lat
              markerData.lng = newLatLng.lng
              showToast('位置已保存')
            } else {
              e.target.setLatLng(oldLatLng)
              showToast(data.message || '位置保存失败')
            }
          } catch (error) {
            e.target.setLatLng(oldLatLng)
            showToast('位置保存失败')
          }
        })

        leafletMarkers.value.push(leafletMarker)
      })
    }

    // 居民管理
    const openResidentModal = (resident) => {
      editingResident.value = resident
      if (resident) {
        residentForm.value = {
          name: resident.name,
          title: resident.title,
          avatarUrl: resident.avatarUrl || '',
          sortOrder: resident.sortOrder || 0
        }
      } else {
        // 自动计算最大序号+1
        const maxSort = residents.value.length > 0 
          ? Math.max(...residents.value.map(r => r.sortOrder || 0)) 
          : 0
        residentForm.value = { name: '', title: '居民', avatarUrl: '', sortOrder: maxSort + 1 }
      }
      originalResidentForm.value = JSON.parse(JSON.stringify(residentForm.value))
      residentModalActive.value = true
      resetModalScroll()
    }

    const closeResidentModal = () => {
      residentModalActive.value = false
      editingResident.value = null
      residentAvatarPreview.value = null
      uploadFile.value = null
    }

    const saveResident = async () => {
      if (!residentForm.value.name.trim() || !residentForm.value.title.trim()) {
        showToast('请输入居民名称和职位')
        return
      }

      // 新增时不做“未修改”判断；编辑时如果没有变化则不提交
      if (editingResident.value && JSON.stringify(residentForm.value) === JSON.stringify(originalResidentForm.value)) {
        showToast('未修改任何内容')
        closeResidentModal()
        return
      }

      try {
        const url = editingResident.value
          ? `${API_BASE}/api/admin/residents/${editingResident.value.id}`
          : `${API_BASE}/api/admin/residents`
        const method = editingResident.value ? 'PUT' : 'POST'
        const res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify(residentForm.value)
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('保存成功')
          closeResidentModal()
          loadData()
        } else {
          showToast('保存失败')
        }
      } catch (error) {
        showToast('保存失败')
      }
    }

    const deleteResident = async (id) => {
      if (!(await mcConfirm('确定要删除这个居民吗？'))) return
      try {
        const res = await fetch(`${API_BASE}/api/admin/residents/${id}`, {
          method: 'DELETE',
          headers: { ...getAdminAuthHeader() }
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('删除成功')
          loadData()
        } else {
          showToast('删除失败')
        }
      } catch (error) {
        showToast('删除失败')
      }
    }

    // 建筑管理
    const openBuildingModal = (building) => {
      editingBuilding.value = building
      buildingImagesPreviews.value = []
      uploadFile.value = null

      if (building) {
        let images = []
        let descriptionJson = ''
        try {
          if (building.images) {
            let parsedImages = building.images
            if (typeof building.images === 'string') {
              try {
                parsedImages = JSON.parse(building.images)
              } catch (e) {
                if (building.images.includes(',')) {
                  parsedImages = building.images.split(',').map(u => u.trim()).filter(Boolean)
                } else {
                  parsedImages = [building.images]
                }
              }
            }
            if (Array.isArray(parsedImages)) {
              images = parsedImages.filter((u) => typeof u === 'string' && u.trim()).map((u) => u.trim())
            }
          }
          if (building.description) {
            let parsedDesc = building.description
            if (typeof building.description === 'string') {
              try {
                parsedDesc = JSON.parse(building.description)
              } catch (e) {
                parsedDesc = building.description.split('\n').map(l => l.trim()).filter(Boolean)
              }
            }
            if (Array.isArray(parsedDesc)) {
              descriptionJson = parsedDesc.join('\n')
            } else if (typeof parsedDesc === 'string') {
              descriptionJson = parsedDesc
            }
          }
        } catch (e) {
          console.error('openBuildingModal parse error', e)
        }

        buildingForm.value = {
          name: building.name,
          subtitle: building.subtitle || '',
          date: building.date === 'unknown' ? 'unknown' : (building.date ? 'date' : ''),
          dateValue: building.date === 'unknown' ? '' : (building.date || ''),
          author: building.author || '',
          coverImage: building.coverImage || '',
          images,
          imagesJson: images.join('\n'),
          descriptionJson: descriptionJson,
          sortOrder: building.sortOrder || 0
        }
      } else {
        buildingForm.value = {
          name: '',
          subtitle: '',
          date: '',
          dateValue: '',
          author: '',
          coverImage: '',
          images: [],
          imagesJson: '',
          descriptionJson: '',
          sortOrder: 0
        }
      }

      originalBuildingForm.value = JSON.parse(JSON.stringify(buildingForm.value))
      buildingModalActive.value = true
      resetModalScroll()

      nextTick(() => {
        syncBuildingDescriptionTextareaHeight()
      })
    }

    const closeBuildingModal = () => {
      buildingModalActive.value = false
      editingBuilding.value = null
      buildingCoverPreview.value = null
      buildingImagesPreviews.value = []
      uploadFile.value = null

      // 清理上传队列并释放 object URL（避免多图预览导致内存上涨、卡顿）
      if (Array.isArray(buildingUploadQueue.value)) {
        buildingUploadQueue.value.forEach((item) => {
          try {
            if (item && item.localUrl) URL.revokeObjectURL(item.localUrl)
          } catch (e) {
            // ignore
          }
        })
        buildingUploadQueue.value = []
      }

      // 清理轮播图数据
      if (buildingForm.value) {
        buildingForm.value.images = []
        buildingForm.value.imagesJson = ''
      }
      // 关闭原因弹窗并清理
      buildingReasonModalActive.value = false
      buildingReason.value = ''
      pendingBuildingAction.value = null
      pendingBuildingId.value = null
      pendingBuildingData.value = null
    }

    const saveBuilding = async () => {
      // 1. 建筑名称必填
      if (!buildingForm.value.name || !String(buildingForm.value.name).trim()) {
        showToast('请输入建筑名称')
        return
      }

      // 2. 副标题必填
      if (!buildingForm.value.subtitle || !String(buildingForm.value.subtitle).trim()) {
        showToast('请输入副标题')
        return
      }

      // 3. 建筑师必填
      if (!buildingForm.value.author || !String(buildingForm.value.author).trim()) {
        showToast('请输入建筑师')
        return
      }

      // 4. 日期必填且合法，且范围必须在 [2024-01-01, 今天]
      if (!buildingForm.value.date || !String(buildingForm.value.date).trim()) {
        showToast('请选择建成时间')
        return
      }
      // 选择“未知”直接通过日期校验
      if (buildingForm.value.date !== 'unknown') {
        if (buildingForm.value.date !== 'date') {
          showToast('请选择建成时间')
          return
        }
        if (!buildingForm.value.dateValue || !String(buildingForm.value.dateValue).trim()) {
          showToast('请选择建成时间')
          return
        }
        if (!/^\d{4}-\d{2}-\d{2}$/.test(buildingForm.value.dateValue)) {
          showToast('时间格式不对，请使用日历选择')
          return
        }
        const inputDate = new Date(buildingForm.value.dateValue)
        if (isNaN(inputDate.getTime())) {
          showToast('你填的时间有误！请仔细检查~')
          return
        }
        const now = new Date()
        const minDate = new Date('2024-01-01')
        if (inputDate < minDate) {
          showToast('时间不能早于 2024 年')
          return
        }
        if (inputDate > now) {
          showToast('日期不能大于当前时间')
          return
        }
      }

      // 5. 描述必填（编辑时不做字数限制）
      const descriptionLines = String(buildingForm.value.descriptionJson || '')
        .split('\n')
        .map((l) => l.trim())
        .filter(Boolean)
      const totalDescChars = descriptionLines.join('').length
      if (descriptionLines.length === 0 || totalDescChars === 0) {
        showToast('请输入建筑描述')
        return
      }
      const isEdit = !!editingBuilding.value
      if (!isEdit) {
        if (totalDescChars < 100) {
          showToast('描述内容至少需要 100 字')
          return
        }
        if (totalDescChars > 5000) {
          showToast('描述内容不能超过 5000 字')
          return
        }
      }

      // 6. 图片数量校验（编辑时兼容老数据）
      const images = buildingForm.value.images || []
      if (!Array.isArray(images)) {
        showToast('请上传建筑图片')
        return
      }
      if (!isEdit) {
        if (images.length < 3) {
          showToast('建筑图片至少需要 3 张')
          return
        }
        if (images.length > 10) {
          showToast('建筑图片最多只能上传 10 张')
          return
        }
      }

      // 7. 封面图必填（取第一张）
      if (!buildingForm.value.coverImage || !String(buildingForm.value.coverImage).trim()) {
        buildingForm.value.coverImage = images[0] || ''
      }
      if (!buildingForm.value.coverImage) {
        showToast('请上传建筑图片')
        return
      }

      // 编辑建筑时检查是否有修改
      if (editingBuilding.value) {
        // 检查是否有修改
        if (JSON.stringify(buildingForm.value) === JSON.stringify(originalBuildingForm.value)) {
          showToast('未修改任何内容')
          closeBuildingModal()
          return
        }
        // 判断是否为用户发布的建筑（需要原因）：先二次确认，再弹原因弹窗
        if (isUserPublishedBuilding(editingBuilding.value)) {
          // 在 await 异步操作前锁定 ID 和数据
          const currentBuildingId = editingBuilding.value.id
          
          if (!(await mcConfirm('确定要修改这个用户发布的建筑吗？'))) return

          // 关键修复：确认后再次检查 currentBuildingId
          if (!currentBuildingId) {
            showToast('建筑ID缺失，请重新打开再试')
            return
          }

          showToast('请填写修改原因')
          pendingBuildingAction.value = 'update'
          pendingBuildingId.value = currentBuildingId
          pendingBuildingData.value = null
          buildingReason.value = ''
          buildingReasonModalActive.value = true
          return
        }
        // 非用户建筑直接保存
        try {
          const description = buildingForm.value.descriptionJson
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line)

          const buildingData = {
            name: buildingForm.value.name,
            subtitle: buildingForm.value.subtitle,
            date: buildingForm.value.date === 'unknown' ? 'unknown' : String(buildingForm.value.dateValue || '').trim(),
            author: buildingForm.value.author,
            coverImage: buildingForm.value.coverImage,
            images: JSON.stringify(buildingForm.value.images || []),
            description: JSON.stringify(description),
            sortOrder: buildingForm.value.sortOrder
          }

          const url = `${API_BASE}/api/admin/buildings/${editingBuilding.value.id}`
          const res = await fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
            body: JSON.stringify(buildingData)
          })
          const data = await res.json()
          if (data.code === 200) {
            showToast('保存成功')
            closeBuildingModal()
            loadData()
          } else {
            showToast(data.message || '保存失败')
          }
        } catch (error) {
          showToast('保存失败')
        }
        return
      }

      try {
        // 处理图片和描述JSON
        const description = buildingForm.value.descriptionJson
          .split('\n')
          .map((line) => line.trim())
          .filter((line) => line)

        const buildingData = {
          name: buildingForm.value.name,
          subtitle: buildingForm.value.subtitle,
          date: buildingForm.value.date,
          author: buildingForm.value.author,
          coverImage: buildingForm.value.coverImage,
          images: JSON.stringify(buildingForm.value.images || []),
          description: JSON.stringify(description),
          sortOrder: buildingForm.value.sortOrder
        }

        const url = `${API_BASE}/api/admin/buildings`
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify(buildingData)
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('保存成功')
          closeBuildingModal()
          loadData()
        } else {
          showToast(data.message || '保存失败')
        }
      } catch (error) {
        showToast('保存失败')
      }
    }

    const deleteBuilding = async (id) => {
      if (!(await mcConfirm('确定要删除这个建筑吗？'))) return

      // 友好提示：重复删除/数据已刷新导致本地列表不存在
      const target = (Array.isArray(buildings.value) ? buildings.value.find((b) => b && b.id === id) : null)
      if (!target) {
        showToast('该建筑不存在！')
        loadData()
        return
      }

      // 仅“用户发布的建筑”删除需要原因：先二次确认，再弹原因弹窗

      if (isUserPublishedBuilding(target)) {
        if (!(await mcConfirm('确定要删除这个用户发布的建筑吗？'))) return
        showToast('请填写删除原因')
        pendingBuildingAction.value = 'delete'
        pendingBuildingId.value = id
        pendingBuildingData.value = null
        buildingReason.value = ''
        buildingReasonModalActive.value = true
        return
      }

      // 非用户建筑：直接删除
      try {
        const res = await fetch(`${API_BASE}/api/admin/buildings/${id}`, {
          method: 'DELETE',
          headers: { ...getAdminAuthHeader() }
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast(data.message || '删除成功')
          loadData()
        } else {
          const msg = String(data && data.message ? data.message : '')
          if (data && (data.code === 404 || msg.includes('不存在') || msg.includes('not exist') || msg.includes('not found'))) {
            showToast('该建筑不存在！')
            loadData()
          } else {
            showToast(data.message || '删除失败')
          }
        }
      } catch (e) {
        showToast('删除失败')
      }
    }

    const closeBuildingReasonModal = () => {
      buildingReasonModalActive.value = false
      buildingReason.value = ''
      pendingBuildingAction.value = null
      pendingBuildingId.value = null
      pendingBuildingData.value = null
    }

    const confirmBuildingReason = async () => {
      const reason = (buildingReason.value || '').trim()
      if (!reason) {
        showToast(pendingBuildingAction.value === 'delete' ? '请填写删除原因' : '请填写修改原因')
        return
      }

      if (pendingBuildingAction.value === 'delete') {
        const id = pendingBuildingId.value
        if (!id) return
        try {
          const res = await fetch(`${API_BASE}/api/admin/buildings/${id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
            body: JSON.stringify({ reason })
          })
          const data = await res.json()
          if (data.code === 200) {
            showToast(data.message || '删除成功')
            closeBuildingReasonModal()
            loadData()
          } else {
            showToast(data.message || '删除失败')
          }
        } catch (e) {
          showToast('删除失败')
        }
        return
      }

      if (pendingBuildingAction.value === 'update') {
        const id = pendingBuildingId.value
        if (!id) return

        try {
          const description = buildingForm.value.descriptionJson
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line)

          const buildingData = {
            name: buildingForm.value.name,
            subtitle: buildingForm.value.subtitle,
            date: buildingForm.value.date === 'unknown' ? 'unknown' : String(buildingForm.value.dateValue || '').trim(),
            author: buildingForm.value.author,
            coverImage: buildingForm.value.coverImage,
            images: JSON.stringify(buildingForm.value.images || []),
            description: JSON.stringify(description),
            sortOrder: buildingForm.value.sortOrder,
            reason
          }

          const res = await fetch(`${API_BASE}/api/admin/buildings/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
            body: JSON.stringify(buildingData)
          })
          const data = await res.json()
          if (data.code === 200) {
            showToast(data.message || '保存成功')
            closeBuildingReasonModal()
            closeBuildingModal()
            loadData()
          } else {
            showToast(data.message || '保存失败')
          }
        } catch (e) {
          showToast('保存失败')
        }
      }
    }



    // 编年史管理
    const openChronicleModal = (chronicle) => {
      editingChronicle.value = chronicle
      if (chronicle) {
        chronicleForm.value = {
          date: chronicle.date,
          title: chronicle.title,
          content: chronicle.content,
          sortOrder: chronicle.sortOrder || 0
        }
      } else {
        chronicleForm.value = { date: '', title: '', content: '', sortOrder: 0 }
      }
      originalChronicleForm.value = JSON.parse(JSON.stringify(chronicleForm.value))
      chronicleModalActive.value = true
      resetModalScroll()
    }

    const closeChronicleModal = () => {
      chronicleModalActive.value = false
      editingChronicle.value = null
    }

    const saveChronicle = async () => {
      if (!chronicleForm.value.date.trim() || !chronicleForm.value.title.trim() || !chronicleForm.value.content.trim()) {
        showToast('请填写完整信息')
        return
      }

      // 新增时不做"未修改"判断；编辑时如果没有变化则不提交
      if (editingChronicle.value && JSON.stringify(chronicleForm.value) === JSON.stringify(originalChronicleForm.value)) {
        showToast('未修改任何内容')
        closeChronicleModal()
        return
      }

      try {
        const url = editingChronicle.value
          ? `${API_BASE}/api/admin/chronicles/${editingChronicle.value.id}`
          : `${API_BASE}/api/admin/chronicles`
        const method = editingChronicle.value ? 'PUT' : 'POST'
        const res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify(chronicleForm.value)
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('保存成功')
          closeChronicleModal()
          loadData()
        } else {
          showToast('保存失败')
        }
      } catch (error) {
        showToast('保存失败')
      }
    }

    const deleteChronicle = async (id) => {
      if (!(await mcConfirm('确定要删除这条编年史吗？'))) return
      try {
        const res = await fetch(`${API_BASE}/api/admin/chronicles/${id}`, {
          method: 'DELETE',
          headers: { ...getAdminAuthHeader() }
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('删除成功')
          loadData()
        } else {
          showToast('删除失败')
        }
      } catch (error) {
        showToast('删除失败')
      }
    }

    // ========== 轮播图管理 ==========
    const openCarouselModal = (carousel) => {
      editingCarousel.value = carousel
      if (carousel) {
        carouselForm.value = {
          imageUrl: carousel.imageUrl || '',
          title: carousel.title || '',
          sortOrder: carousel.sortOrder || 0,
          isActive: carousel.isActive !== undefined ? carousel.isActive : 1
        }
      } else {
        // 自动计算最大序号+1
        const maxSort = carousels.value.length > 0
          ? Math.max(...carousels.value.map(c => c.sortOrder || 0))
          : 0
        carouselForm.value = { imageUrl: '', title: '', sortOrder: maxSort + 1, isActive: 1 }
      }
      originalCarouselForm.value = JSON.parse(JSON.stringify(carouselForm.value))
      uploadFile.value = null
      carouselModalActive.value = true
      resetModalScroll()
    }

    const closeCarouselModal = () => {
      carouselModalActive.value = false
      editingCarousel.value = null
      carouselForm.value = { imageUrl: '', title: '', link: '', sortOrder: 0, isActive: 1 }
      uploadFile.value = null
      carouselPreview.value = null
    }

    // 轮播图：选择文件并预览
    const handleCarouselFileChange = (e) => {
      const file = e.target.files[0]
      if (!file) return
      uploadFile.value = file
      const reader = new FileReader()
      reader.onload = (e) => {
        carouselPreview.value = e.target.result
      }
      reader.readAsDataURL(file)
    }

    // 轮播图：上传图片
    const uploadCarouselImage = async () => {
      if (!uploadFile.value) {
        showToast('请先选择图片')
        return
      }
      try {
        const formData = new FormData()
        formData.append('file', uploadFile.value)
        const res = await fetch(`${API_BASE}/upload/image`, {
          method: 'POST',
          body: formData
        })
        const data = await res.json()
        if (data.code === 200) {
          carouselForm.value.imageUrl = data.url
          carouselPreview.value = null
          uploadFile.value = null
          showToast('图片上传成功')
        } else {
          showToast('图片上传失败: ' + data.message)
        }
      } catch (error) {
        showToast('图片上传失败')
      }
    }

    // 居民头像：选择文件并预览
    const handleResidentAvatarChange = (e) => {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = (e) => {
        residentAvatarPreview.value = e.target.result
      }
      reader.readAsDataURL(file)
      // 保存文件用于上传
      uploadFile.value = file
    }

    // 居民头像：上传图片
    const uploadResidentAvatar = async () => {
      if (!uploadFile.value) {
        showToast('请先选择图片')
        return
      }
      try {
        const formData = new FormData()
        formData.append('file', uploadFile.value)
        const res = await fetch(`${API_BASE}/upload/image`, {
          method: 'POST',
          body: formData
        })
        const data = await res.json()
        if (data.code === 200) {
          residentForm.value.avatarUrl = data.url
          residentAvatarPreview.value = null
          uploadFile.value = null
          showToast('头像上传成功')
        } else {
          showToast('头像上传失败: ' + data.message)
        }
      } catch (error) {
        showToast('头像上传失败')
      }
    }


    // 建筑图片上传队列（限制并发，避免多图同时上传导致卡顿/错位）
    // 队列项结构：{ id, file, localUrl, status: 'pending'|'uploading'|'success'|'error', remoteUrl, error, retry }
    const buildingUploadQueue = ref([])
    const MAX_BUILDING_UPLOAD_CONCURRENCY = 2
    const buildingUploadingCount = ref(0)

    const enqueueBuildingFiles = (files) => {
      if (!Array.isArray(files) || files.length === 0) return
      files.forEach((file) => {
        const id = `${Date.now()}_${Math.random().toString(16).slice(2)}`
        const localUrl = URL.createObjectURL(file)
        buildingUploadQueue.value.push({
          id,
          file,
          localUrl,
          status: 'pending',
          remoteUrl: '',
          error: '',
          retry: 0
        })
      })
      processBuildingUploadQueue()
    }

    // 选择文件后：直接入队（不再 FileReader base64 预览）
    const handleBuildingImagesChange = (e) => {
      const files = Array.from(e.target.files || [])
      if (files.length === 0) return

      const currentCount = Array.isArray(buildingForm.value.images) ? buildingForm.value.images.length : 0
      const uploadingCount = Array.isArray(buildingUploadQueue.value) ? buildingUploadQueue.value.length : 0
      const totalAfterSelect = currentCount + uploadingCount + files.length

      if (totalAfterSelect > 10) {
        showToast('建筑图片最多只能上传 10 张')
        return
      }

      enqueueBuildingFiles(files)
      // 允许重复选择同一批文件
      try {
        e.target.value = ''
      } catch (err) {
        // ignore
      }
    }

    const uploadOneBuildingQueueItem = async (item) => {
      item.status = 'uploading'
      item.error = ''
      buildingUploadingCount.value += 1
      try {
        const formData = new FormData()
        formData.append('file', item.file)
        const res = await fetch(`${API_BASE}/upload/image`, { method: 'POST', body: formData })
        const data = await res.json()
        if (data && data.code === 200 && data.url) {
          item.status = 'success'
          item.remoteUrl = data.url

          if (!Array.isArray(buildingForm.value.images)) buildingForm.value.images = []

          // 上限保护：并发上传过程中也避免超过 10 张
          if (buildingForm.value.images.length >= 10) {
            item.status = 'error'
            item.error = '建筑图片最多只能上传 10 张'
          } else {
            buildingForm.value.images.push(data.url)

            // 第一张图片自动作为封面（方案A：已有封面则不覆盖）
            if (!buildingForm.value.coverImage) {
              buildingForm.value.coverImage = data.url
            }

            buildingForm.value.imagesJson = (buildingForm.value.images || []).join('\n')
          }

          // 成功项自动从队列移除（释放 objectURL，避免队列越积越多导致卡顿）
          setTimeout(() => {
            const idx = buildingUploadQueue.value.findIndex((x) => x && x.id === item.id)
            if (idx >= 0) {
              const it = buildingUploadQueue.value[idx]
              try {
                if (it && it.localUrl) URL.revokeObjectURL(it.localUrl)
              } catch (e) {
                // ignore
              }
              buildingUploadQueue.value.splice(idx, 1)
            }
          }, 800)
        } else {
          item.status = 'error'
          item.error = (data && data.message) ? data.message : '图片上传失败'
        }
      } catch (e) {
        item.status = 'error'
        item.error = '图片上传失败'
      } finally {
        buildingUploadingCount.value = Math.max(0, buildingUploadingCount.value - 1)
      }
    }

    const processBuildingUploadQueue = async () => {
      while (buildingUploadingCount.value < MAX_BUILDING_UPLOAD_CONCURRENCY) {
        const next = buildingUploadQueue.value.find((x) => x.status === 'pending')
        if (!next) break
        // 不 await，启动并发任务
        uploadOneBuildingQueueItem(next).finally(() => {
          processBuildingUploadQueue()
        })
      }
    }

    const retryBuildingUpload = (id) => {
      const item = buildingUploadQueue.value.find((x) => x.id === id)
      if (!item) return
      if (item.retry >= 2) {
        showToast('重试次数过多')
        return
      }
      item.retry += 1
      item.status = 'pending'
      item.error = ''
      processBuildingUploadQueue()
    }

    const removeBuildingUploadItem = (id) => {
      const idx = buildingUploadQueue.value.findIndex((x) => x && x.id === id)
      if (idx < 0) return
      const it = buildingUploadQueue.value[idx]
      try {
        if (it && it.localUrl) URL.revokeObjectURL(it.localUrl)
      } catch (e) {
        // ignore
      }
      buildingUploadQueue.value.splice(idx, 1)
    }

    // 兼容旧模板调用（已不再使用）
    const uploadBuildingImage = async () => {}


    // 删除已上传图片 + 封面回退
    const removeBuildingImage = (index) => {
      if (!Array.isArray(buildingForm.value.images)) return
      const removed = buildingForm.value.images[index]
      buildingForm.value.images.splice(index, 1)

      // 如果删除的是封面图，自动切换封面
      if (buildingForm.value.coverImage === removed) {
        buildingForm.value.coverImage = buildingForm.value.images[0] || ''
      }
    }

    // 拖拽排序
    let draggedIndex = null
    const handleImageDragStart = (e, index) => {
      draggedIndex = index
      e.dataTransfer.effectAllowed = 'move'
    }
    const handleImageDragOver = (e) => {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
    }
    const handleImageDrop = (e, targetIndex) => {
      e.preventDefault()
      if (draggedIndex === null || draggedIndex === targetIndex) return
      const items = [...buildingForm.value.images]
      const [removed] = items.splice(draggedIndex, 1)
      items.splice(targetIndex, 0, removed)
      buildingForm.value.images = items

      // 如果拖动的是封面图，封面也跟着走
      if (draggedIndex === 0) {
        buildingForm.value.coverImage = items[0] || ''
      } else if (targetIndex === 0) {
        buildingForm.value.coverImage = items[0] || ''
      }
      draggedIndex = null
    }

    const saveCarousel = async () => {
      if (!carouselForm.value.imageUrl.trim()) {
        showToast('请上传图片')
        return
      }

      // 新增时不做"未修改"判断；编辑时如果没有变化则不提交
      if (editingCarousel.value && JSON.stringify(carouselForm.value) === JSON.stringify(originalCarouselForm.value)) {
        showToast('未修改任何内容')
        closeCarouselModal()
        return
      }

      try {
        const url = editingCarousel.value
          ? `${API_BASE}/api/admin/carousels/${editingCarousel.value.id}`
          : `${API_BASE}/api/admin/carousels`
        const method = editingCarousel.value ? 'PUT' : 'POST'
        const res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json', ...getAdminAuthHeader() },
          body: JSON.stringify(carouselForm.value)
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('保存成功')
          closeCarouselModal()
          loadData()
        } else {
          showToast('保存失败')
        }
      } catch (error) {
        showToast('保存失败')
      }
    }

    const deleteCarousel = async (id) => {
      if (!(await mcConfirm('确定要删除这张轮播图吗？'))) return
      try {
        const res = await fetch(`${API_BASE}/api/admin/carousels/${id}`, {
          method: 'DELETE',
          headers: { ...getAdminAuthHeader() }
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('删除成功')
          loadData()
        } else {
          showToast('删除失败')
        }
      } catch (error) {
        showToast('删除失败')
      }
    }

    const openMapUploadModal = () => {
      mapUploadModalActive.value = true
      resetModalScroll()
    }

    const closeMapUploadModal = () => {
      mapUploadModalActive.value = false
      mapUploadFile.value = null
      mapUploadPreview.value = null
      if (mapFileInput.value) {
        mapFileInput.value.value = ''
      }
    }

    const handleMapFileChange = (e) => {
      const file = e.target.files && e.target.files[0]
      mapUploadFile.value = file || null
      if (file) {
        const reader = new FileReader()
        reader.onload = (ev) => {
          mapUploadPreview.value = ev.target.result
        }
        reader.readAsDataURL(file)
      } else {
        mapUploadPreview.value = null
      }
    }

    const loadMapImage = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/map-config`)
        const data = await res.json()
        if (data.code === 200 && data.data && data.data.mapUrl) {
          mapImageUrl.value = data.data.mapUrl
        } else {
          mapImageUrl.value = ''
        }
      } catch (e) {
        mapImageUrl.value = ''
      }
    }

    const applyMapImageOverlay = async () => {
      if (!adminMap.value) return

      const rawUrl = mapImageUrl.value || 'https://images.unsplash.com/photo-1541701494587-cb58502866ab?auto=format&fit=crop&w=2000&q=80'
      const url = rawUrl.startsWith('http') ? `${API_BASE}/api/map-proxy?url=${encodeURIComponent(rawUrl)}` : rawUrl

      // 关键：用图片真实尺寸作为 CRS.Simple 的 bounds，避免图片不显示/显示成一片灰
      const getImageSize = (src) =>
        new Promise((resolve, reject) => {
          const img = new Image()
          img.onload = () => resolve({ width: img.naturalWidth || img.width, height: img.naturalHeight || img.height })
          img.onerror = reject
          img.src = src
        })

      let size
      try {
        size = await getImageSize(url)
      } catch (e) {
        console.error('[AdminMap] load image failed:', url, e)
        return
      }

      const imgBounds = [[0, 0], [size.height, size.width]]

      if (mapImageOverlay) {
        mapImageOverlay.remove()
        mapImageOverlay = null
      }

      mapImageOverlay = L.imageOverlay(url, imgBounds, { crossOrigin: true }).addTo(adminMap.value)
      adminMap.value.fitBounds(imgBounds, { animate: false })
      adminMap.value.zoomIn(2, { animate: false })
    }

    const confirmUploadMapImage = async () => {
      if (!mapUploadFile.value) {
        showToast('请先选择图片')
        return
      }
      try {
        const formData = new FormData()
        formData.append('file', mapUploadFile.value)
        const res = await fetch(`${API_BASE}/api/admin/map-config/upload`, {
          method: 'POST',
          headers: { ...getAdminAuthHeader() },
          body: formData
        })
        const data = await res.json()
        if (data.code === 200 && data.data && data.data.mapUrl) {
          mapImageUrl.value = data.data.mapUrl
          mapUploadFile.value = null
          showToast('上传成功')
          closeMapUploadModal()
          await applyMapImageOverlay()
        } else {
          showToast(data.message || '上传失败')
        }
      } catch (e) {
        showToast('上传失败')
      }
    }

    const applyMapLockState = () => {
      if (!adminMap.value) return

      // 地图拖拽
      if (mapLocked.value) {
        adminMap.value.dragging.disable()
      } else {
        adminMap.value.dragging.enable()
      }

      // 标点拖拽
      leafletMarkers.value.forEach((m) => {
        if (!m || !m.dragging) return
        if (mapLocked.value) {
          m.dragging.enable()
        } else {
          m.dragging.disable()
        }
      })
    }

    // 在 setup 同步阶段注册 watch，避免 onUnmounted 注入时机错误
    const stopMapLockedWatch = watch(mapLocked, () => {
      applyMapLockState()
    })

    let mapContainer = null
    let onContainerContextMenu = null

    const initMap = async () => {
      const mapElement = document.getElementById('admin-map')
      if (!mapElement) return

      adminMap.value = L.map('admin-map', {
        crs: L.CRS.Simple,
        minZoom: -2,
        maxZoom: 2,
        scrollWheelZoom: true,
        dragging: !mapLocked.value,
        attributionControl: false
      })

      mapContainer = adminMap.value.getContainer()
      onContainerContextMenu = (ev) => {
        ev.preventDefault()
      }
      mapContainer.addEventListener('contextmenu', onContainerContextMenu)

      // 右键点地图空白处：新建标点
      adminMap.value.on('contextmenu', (e) => {
        openMarkerModal({ name: '', lat: e.latlng.lat, lng: e.latlng.lng })
      })

      adminMap.value.on('zoomend', () => {
        document.documentElement.style.setProperty(
          '--map-scale',
          Math.pow(1.5, adminMap.value.getZoom())
        )
      })

      // 初始化底图（先拉配置，再根据图片真实尺寸设置 bounds）
      await loadMapImage()
      await applyMapImageOverlay()

      // 标点与锁定状态
      updateMapMarkers()
      applyMapLockState()
    }

    onMounted(() => {
      window.addEventListener('keydown', onGlobalKeydown)
      nextTick(async () => {
        await initMap()
      })
      loadData()
      refreshUnreadMailCount()

      // 如果刷新时初始 Tab 就是流量监控，需要主动触发一次渲染（watch 只在值变化时触发）
      if (activeTab.value === 'traffic') {
        waitForTrafficMapReady().then(() => loadTrafficStats())
        connectTrafficWs()
      }
    })

    onUnmounted(() => {
      window.removeEventListener('keydown', onGlobalKeydown)
      closeTrafficWs()
      // 停止 watch
      stopMapLockedWatch()

      // 清理地图事件监听
      if (mapContainer && onContainerContextMenu) {
        mapContainer.removeEventListener('contextmenu', onContainerContextMenu)
      }

      // 销毁地图实例
      if (adminMap.value) {
        adminMap.value.off()
        adminMap.value.remove()
        adminMap.value = null
      }
      mapImageOverlay = null
    })

    const getUserNickname = (userId) => {
      if (userId == null) return 'UNKNOWN'
      const u = (users.value || []).find((x) => x && String(x.id) === String(userId))
      return (u && u.nickname) ? u.nickname : `UID:${userId}`
    }

    const getNoticeTypeClass = (type) => {
      if (['top', 'security', 'infrastructure', 'normal'].includes(type)) {
        return 'type-' + type
      }
      return 'type-custom'
    }

    const buildingFilter = ref('all')
    const filteredBuildings = computed(() => {
      const list = Array.isArray(buildings.value) ? buildings.value : []
      if (buildingFilter.value === 'user') return list.filter((b) => isUserPublishedBuilding(b))
      if (buildingFilter.value === 'admin') return list.filter((b) => !isUserPublishedBuilding(b))
      return list
    })

    const SZ_COORD = [116.405285,39.904989]

    const loadTrafficStats = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/traffic/stats?period=${trafficPeriod.value}`, {
          headers: getAdminAuthHeader()
        })
        const data = await res.json()
        if (data.code === 200) {
          trafficStats.value = data.data || []
          nextTick(() => {
            renderTrafficMap()
          })
        }
      } catch (e) {
        showToast('加载流量监控失败')
      }
    }

    const changeTrafficPeriod = (p) => {
      trafficPeriod.value = p
      loadTrafficStats()
    }

    const renderTrafficMap = () => {
      if (!trafficMapRef.value) return
      if (!echarts) {
        showToast('ECharts 加载失败')
        return
      }
      initEchartsMap()
    }

    const canResizeTrafficChart = () => {
      return (
        activeTab.value === 'traffic' &&
        trafficMapRef.value &&
        trafficMapRef.value.clientWidth > 0 &&
        trafficMapRef.value.clientHeight > 0 &&
        trafficChart
      )
    }

    const handleResize = () => {
      if (canResizeTrafficChart()) {
        trafficChart.resize()
      }
    }

    const handleAdminTabAfterEnter = () => {
      if (activeTab.value !== 'traffic') return
      // 仅在容器可见且有尺寸时触发渲染/resize，避免 0x0 canvas 导致 echarts drawImage 异常
      waitForTrafficMapReady()
      setTimeout(() => {
        if (canResizeTrafficChart()) trafficChart.resize()
      }, 80)
      setTimeout(() => {
        if (canResizeTrafficChart()) trafficChart.resize()
      }, 200)
    }

    const initEchartsMap = async () => {
      if (!trafficMapRef.value) return
      
      // 检查容器尺寸，如果为0则等待
      if (trafficMapRef.value.clientWidth === 0 || trafficMapRef.value.clientHeight === 0) {
        requestAnimationFrame(() => initEchartsMap())
        return
      }

      if (trafficChart) {
        // 避免在容器 0x0 时 dispose/clear 触发 canvas drawImage 异常
        if (trafficMapRef.value.clientWidth > 0 && trafficMapRef.value.clientHeight > 0) {
        trafficChart.dispose()
        }
        trafficChart = null
      }
      trafficChart = echarts.init(trafficMapRef.value)
      window.addEventListener('resize', handleResize)

      try {
        const base = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.BASE_URL) ? import.meta.env.BASE_URL : '/'
        const mapUrl = new URL('echarts/china.json', window.location.origin + base).toString()
        const mapRes = await fetch(mapUrl)
        if (!mapRes.ok) throw new Error('Map JSON load failed')
        const chinaJson = await mapRes.json()
        echarts.registerMap('china', chinaJson)

        const linesData = []
        const scatterData = []

        // 终点：北京
        scatterData.push({
          name: '北京主机',
          value: [...SZ_COORD, 100],
          itemStyle: { color: '#ff3333', shadowBlur: 10 }
        })

        trafficStats.value.forEach((item) => {
          const lng = Number(item && item.lng)
          const lat = Number(item && item.lat)
          if (!Number.isFinite(lng) || !Number.isFinite(lat)) return

          const fromCoord = [lng, lat]
            linesData.push({
              coords: [fromCoord, SZ_COORD],
            fromName: ((item && item.city) ? String(item.city).trim() : '') || ((item && item.province) ? String(item.province).trim() : '') || ((item && item.country) ? String(item.country).trim() : '') || '未知节点'
            })
            scatterData.push({
            name: ((item && item.city) ? String(item.city).trim() : '') || ((item && item.province) ? String(item.province).trim() : '') || ((item && item.country) ? String(item.country).trim() : '') || '未知节点',
              value: [...fromCoord, 50],
              itemStyle: { color: '#00ffff' }
            })
        })

        const option = {
          backgroundColor: 'transparent',
          tooltip: {
            show: true,
            trigger: 'item',
            backgroundColor: 'rgba(0, 20, 40, 0.8)',
            borderColor: '#00d8ff',
            textStyle: { color: '#fff', fontFamily: 'Minecraft' }
          },
          geo: {
            map: 'china',
            roam: true,
            zoom: 1.2,
            center: [104.0, 35.5],
            label: { show: false },
            itemStyle: {
              areaColor: '#010d1d',
              borderColor: '#1176d4',
              borderWidth: 1.5,
              shadowColor: 'rgba(17, 118, 212, 0.5)',
              shadowBlur: 20
            },
            emphasis: { areaColor: '#0a274b' }
          },
          series: [
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              data: scatterData,
              symbolSize: (val) => Math.max(10, (val[2] || 0) / 5),
              showEffectOn: 'render',
              rippleEffect: { brushType: 'stroke', scale: 4 },
              label: { 
                show: true, 
                position: 'right', 
                formatter: '{b}', 
                color: '#00ffff', 
                fontSize: 10,
                fontFamily: 'Minecraft'
              },
              zlevel: 2
            },
            {
              type: 'lines',
              zlevel: 1,
              effect: {
                show: true,
                period: 3,
                trailLength: 0.5,
                color: '#fff',
                symbolSize: 4
              },
              lineStyle: {
                color: '#00ffff',
                width: 2,
                curveness: 0.3,
                opacity: 0.8
              },
              data: linesData
            }
          ]
        }
        trafficChart.setOption(option, true)
        // 强制在下一帧再次 resize 确保万无一失
        setTimeout(() => trafficChart && trafficChart.resize(), 100)
      } catch (e) {
        console.error('Echarts Map Error:', e)
      }
    }

    const waitForTrafficMapReady = async () => {
      await nextTick()
      await new Promise((r) => setTimeout(r, 60))
      if (trafficMapRef.value && trafficMapRef.value.clientWidth > 0 && trafficMapRef.value.clientHeight > 0) {
        renderTrafficMap()
        return
      }
      // 再等一轮（Transition 动画/布局稳定）
      await new Promise((r) => setTimeout(r, 200))
      if (trafficMapRef.value) {
        renderTrafficMap()
      }
    }

    watch(activeTab, async (newTab) => {
      // 持久化当前选中的 Tab
      localStorage.setItem(TAB_STORAGE_KEY, newTab)
      
      // 同步到 URL query，方便直接通过链接进入特定模块
      const url = new URL(window.location.href)
      if (url.searchParams.get('tab') !== newTab) {
        url.searchParams.set('tab', newTab)
        window.history.replaceState({}, '', url.toString())
      }

      if (newTab === 'traffic') {
        // 先确保容器尺寸稳定后渲染底图，再拉取数据更新飞线
        await waitForTrafficMapReady()
        await loadTrafficStats()
        connectTrafficWs()
      } else {
        closeTrafficWs()
      }
    })

    return {
      todayStr,
      // 邮件管理
      activeTab,
      mailList,
      unreadMailCount,
      replyModalActive,
      replyTarget,
      replyContent,
      mailSearch,
      mailTypeFilter,
      mailUnreadOnly,
      mailSort,
      mailTypeOptions,
      normalizeMailType,
      getMailTypeLabel,
      filteredMailList,
      mailDetailModalActive,
      selectedMail,
      mailBatchMode,
      selectedMailIds,
      selectedMailCount,
      toggleMailBatchMode,
      toggleMailSelection,
      isMailSelectable,
      confirmBatchDelete,
      deleteSingleMail,
      openMailDetail,
      closeMailDetail,
      currentMailIndex,
      loadMailList,
      refreshUnreadMailCount,
      markMailRead,
      openReplyModal,

      handleAdminTabAfterEnter,
      closeReplyModal,
      sendReply,
      notices,
      markers,
      residents,
      buildings,
      chronicles,
      carousels,
      editingNotice,
      editingMarker,
      editingResident,
      editingBuilding,
      editingChronicle,
      editingCarousel,
      noticeModalActive,
      markerModalActive,
      residentModalActive,
      buildingModalActive,
      chronicleModalActive,
      carouselModalActive,
      noticeForm,
      markerForm,
      residentForm,
      isSelected,
      selectDate,
      selectToday,
      clearDate,
      showDatePicker,
      currentYear,
      currentMonth,
      toggleDatePicker,
      prevYear,
      nextYear,
      prevMonth,
      nextMonth,
      daysInMonth,
      firstDayOfMonth,
      buildingForm,
      buildingDescriptionTextarea,
      autoGrowTextarea,
      chronicleForm,
      carouselForm,
      uploadFile,
      carouselPreview,
      buildingUploadQueue,
      retryBuildingUpload,
      removeBuildingUploadItem,
      residentAvatarPreview,
      mapLocked,
      toastActive,
      toastMessage,
      goHome,
      logoutAdmin,
      goBuildingDetail,
      getTypeName,
      getNoticeTypeClass,
      openNoticeModal,
      closeNoticeModal,
      saveNotice,
      deleteNotice,
      openMarkerModal,
      closeMarkerModal,
      saveMarker,
      deleteMarker,
      openResidentModal,
      closeResidentModal,
      saveResident,
      deleteResident,
      handleResidentAvatarChange,
      uploadResidentAvatar,
      openBuildingModal,
      closeBuildingModal,
      saveBuilding,
      deleteBuilding,
      handleBuildingImagesChange,
      uploadBuildingImage,
      removeBuildingImage,
      handleImageDragStart,
      handleImageDragOver,
      handleImageDrop,
      openChronicleModal,
      closeChronicleModal,
      saveChronicle,
      deleteChronicle,
      openCarouselModal,
      closeCarouselModal,
      handleCarouselFileChange,
      uploadCarouselImage,
      saveCarousel,
      validateResidentSortOrder,
      validateCarouselSortOrder,
      deleteCarousel,
      mapFileInput,
      mapUploadFile,
      openMapUploadModal,
      closeMapUploadModal,
      mapUploadModalActive,
      mapUploadPreview,
      mapImageUrl,
      handleMapFileChange,
      confirmUploadMapImage,
      imagePreviewActive,
      imagePreviewUrl,
      openImagePreview,
      closeImagePreview,
      users,
      userNotices,
      formatDateTime,
      openUserNoticeModal,
      closeUserNoticeModal,
      saveUserNotice,
      adminDeleteUserNotice,
      userNoticeModalActive,
      userNoticeForm,
      editingUserNotice,
      buildingReasonModalActive,
      buildingReason,
      pendingBuildingAction,
      closeBuildingReasonModal,
      confirmBuildingReason,

      approveUser,
      openRejectModal,
      closeRejectModal,
      confirmRejectUser,
      rejectModalActive,
      rejectReason,
      rejectTarget,
      enableUser,
      openDisableModal,
      closeDisableModal,
      confirmDisableUser,
      disableModalActive,
      disableReason,
      disableTarget,

      isUserPublishedBuilding,
      getUserNickname,
      buildingFilter,
      filteredBuildings,

      trafficPeriod,
      trafficPeriods,
      trafficStats,
      trafficMapRef,
      loadTrafficStats,
      changeTrafficPeriod,
      // 更新日志
      updateLogs,
      updateLogModalActive,
      editingUpdateLog,
      updateLogForm,
      openUpdateLogModal,
      saveUpdateLog,
      deleteUpdateLog,
      validateVersion,
      loadUpdateLogs
    }
  }
}
</script>

<style>
/* 流量监控面板样式 */
.traffic-panel {
  padding: 10px;
  animation: admin-fade-in 0.3s ease-out;
}

.traffic-content {
  display: flex;
  gap: 20px;
  min-height: 600px;
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid #333;
  padding: 20px;
  position: relative;
}

.traffic-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 0;
}

.traffic-right {
  flex: 1.5;
  min-width: 0;
}

.traffic-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 15px;
  border-bottom: 2px solid #333;
}

.traffic-period-btn {
  font-size: 12px;
  padding: 6px 12px;
}

.traffic-period-btn.active {
  background: #3c8527 !important;
  box-shadow: inset -2px -2px #1d4d13, inset 2px 2px #5fb447 !important;
}

.traffic-table-wrapper {
  flex: 1;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  border: 2px solid #000;
  background: #111;
}

.traffic-table-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #3a3a3a #141414;
}

.traffic-table-wrapper::-webkit-scrollbar {
  width: 10px;
}

.traffic-table-wrapper::-webkit-scrollbar-track {
  background: #141414;
  border-left: 1px solid #000;
}

.traffic-table-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #3a3a3a 0%, #232323 100%);
  border: 1px solid #4a4a4a;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.35);
}

.traffic-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #4a4a4a 0%, #2b2b2b 100%);
}

.traffic-table-wrapper::-webkit-scrollbar-corner {
  background: #141414;
}

.traffic-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Minecraft', monospace;
  font-size: 12px;
  table-layout: fixed; /* 固定布局，防止内容撑开 */
}

.traffic-table th, .traffic-table td {
  padding: 10px;
  border-bottom: 1px solid #222;
  color: #ddd;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.traffic-table th:nth-child(1), .traffic-table td:nth-child(1) { width: 35%; } /* IP */
.traffic-table th:nth-child(2), .traffic-table td:nth-child(2) { width: 20%; } /* 省份 */
.traffic-table th:nth-child(3), .traffic-table td:nth-child(3) { width: 20%; } /* 城市 */
.traffic-table th:nth-child(4), .traffic-table td:nth-child(4) { width: 25%; } /* 次数 */

.traffic-table th {
  background: #222;
  color: #aaa;
  text-align: left;
  padding: 10px;
  border-bottom: 2px solid #333;
  position: sticky;
  top: 0;
}

.traffic-table td {
  padding: 10px;
  border-bottom: 1px solid #222;
  color: #ddd;
}

.traffic-table tr:hover {
  background: rgba(255, 255, 255, 0.05);
}

.traffic-table tr.is-top td {
  color: #00ffff;
  text-shadow: 0 0 5px rgba(0, 255, 255, 0.5);
}

.traffic-empty {
  text-align: center;
  padding: 40px !important;
  color: #666;
}

/* 科技感地图外壳 */
.traffic-map-shell {
  height: 100%;
  background: #000205;
  border: 2px solid #1176d4;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 20px rgba(17, 118, 212, 0.2);
  background-image: 
    linear-gradient(rgba(18, 53, 85, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(18, 53, 85, 0.1) 1px, transparent 1px);
  background-size: 30px 30px;
}

.traffic-map-title {
  padding: 15px;
  text-align: center;
  color: #00d8ff;
  font-size: 18px;
  letter-spacing: 4px;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(0, 216, 255, 0.8);
  border-bottom: 1px solid rgba(17, 118, 212, 0.3);
}

.traffic-map-status {
  position: absolute;
  left: 20px;
  top: 70px;
  z-index: 10;
  background: rgba(0, 40, 80, 0.4);
  border-left: 3px solid #00d8ff;
  padding: 10px;
  color: #00d8ff;
  font-family: monospace;
  font-size: 11px;
  backdrop-filter: blur(5px);
  pointer-events: none;
  line-height: 1.6;
}

.traffic-map-container {
  flex: 1;
  width: 100%;
}

/* 适配 Minecraft 风格的滚动条 */
.traffic-table-wrapper::-webkit-scrollbar {
  width: 12px;
}
.traffic-table-wrapper::-webkit-scrollbar-track {
  background: #111;
}
.traffic-table-wrapper::-webkit-scrollbar-thumb {
  background: #444;
  border: 3px solid #111;
}
.traffic-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 1200px) {
  .traffic-content {
    flex-direction: column;
    min-height: auto;
  }
  .traffic-right {
    height: 520px;
  }
}

@media (max-width: 768px) {
  .traffic-content {
    padding: 12px;
    gap: 12px;
    border-width: 1px;
  }

  .traffic-toolbar {
    padding-bottom: 12px;
  }

  .traffic-period-btn {
    font-size: 12px;
    padding: 8px 12px;
  }

  .traffic-table {
    font-size: 12px;
    min-width: 520px;
  }

  .traffic-table th,
  .traffic-table td {
    padding: 8px;
  }

  .traffic-right {
    height: 420px;
    min-width: 0;
  }

  .traffic-map-title {
    font-size: 14px;
    letter-spacing: 2px;
    padding: 12px;
  }

  .traffic-map-status {
    left: 10px;
    top: 54px;
    padding: 8px;
    font-size: 10px;
  }
}

@media (max-width: 420px) {
  .traffic-right {
    height: 340px;
  }

  .traffic-map-status {
    left: 8px;
    top: 50px;
    max-width: calc(100% - 16px);
  }
}

/* 标签切换动画：优雅慢速平移淡入（更柔和、更连贯） */
.admin-tab-fade-enter-active {
  transition: opacity 400ms ease-out, transform 450ms cubic-bezier(0.3, 0.9, 0.3, 1);
}
.admin-tab-fade-leave-active {
  transition: opacity 300ms ease-in, transform 350ms cubic-bezier(0.3, 0.9, 0.3, 1);
}

.admin-tab-fade-enter-from {
  opacity: 0;
  transform: translateY(12px) scale(0.99);
}
.admin-tab-fade-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.admin-tab-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}
.admin-tab-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.995);
}

.update-timeline {
  margin-top: 30px;
  position: relative;
  padding-left: 40px;
  padding-bottom: 20px;
}
.update-timeline::before {
  content: '';
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  width: 6px;
  background: #000;
  box-shadow: inset -2px -2px 0 #555, inset 2px 2px 0 #888;
}
.timeline-node {
  position: relative;
  margin-bottom: 40px;
}
.timeline-node:last-child {
  margin-bottom: 0;
}
.node-dot {
  position: absolute;
  left: -39px;
  top: 4px;
  width: 20px;
  height: 20px;
  background: var(--mc-green);
  border: 4px solid #000;
  box-shadow: inset -3px -3px 0 #3c6b10, inset 3px 3px 0 #9ae054;
  z-index: 2;
}
.node-content {
  background: #d1d1d1;
  border: 4px solid #000;
  padding: 20px;
  position: relative;
  box-shadow: inset -4px -4px 0 #888, inset 4px 4px 0 #eee, 8px 8px 0 rgba(0,0,0,0.2);
}
.node-content::before {
  content: '';
  position: absolute;
  left: -14px;
  top: 8px;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 10px solid #000;
}
.node-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  border-bottom: 3px dashed #888;
  padding-bottom: 10px;
}
.node-version {
  font-size: 18px;
  color: #2f7d1b;
  font-weight: bold;
  text-shadow: 1px 1px 0 #fff;
}
.node-date {
  font-size: 12px;
  color: #555;
  font-weight: bold;
}
.node-body {
  font-size: 14px;
  color: #1b1b1b;
  line-height: 1.8;
  white-space: pre-wrap;
  margin-bottom: 18px;
  font-family: 'Microsoft YaHei', sans-serif;
}
.node-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.empty-timeline {
  text-align: center;
  padding: 60px;
  color: #666;
  font-size: 14px;
  background: rgba(0,0,0,0.05);
  border: 4px dashed #888;
}
.mc-form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 15px;
}
.mc-form-item label {
  font-size: 12px;
  color: #000;
  font-weight: bold;
}

:root {
  --mc-oak: #c69c6d;
  --mc-oak-dark: #7d5a35;
  --mc-oak-text: #372511;
  --mc-green: #5ea818;
  --mc-bg: #121213;
  --mc-stone: #7a7a7a;
  --map-scale: 1;
}

.admin-container {
  min-height: 100vh;
  background-color: var(--mc-bg);
  color: white;
  padding-top: 100px;
}

/* 移动端适配：不改结构，先保证不溢出/不遮挡 */
@media (max-width: 768px) {
  .admin-container {
    padding-top: 130px;
  }

  .admin-nav {
    padding: 12px 12px;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .admin-nav-left {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .admin-nav-tabs {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
  }

  .nav-tab-btn {
    flex: 1 1 auto;
    min-width: 0;
    padding: 10px 12px;
  }

  .admin-nav-actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .back-link {
    white-space: nowrap;
  }

  .admin-content {
    padding-left: 12px;
    padding-right: 12px;
  }

  .mc-modal {
    width: calc(100vw - 24px) !important;
    max-width: 520px;
    left: 50% !important;
    transform: translateX(-50%) !important;
    right: auto !important;
    max-height: calc(100dvh - 24px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mail-paper {
    width: calc(100vw - 24px) !important;
    max-height: calc(100dvh - 24px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mail-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .mail-toolbar-group {
    width: 100%;
  }

  .mail-grid {
    grid-template-columns: 1fr !important;
  }

  .item-actions {
    flex-wrap: wrap !important;
    justify-content: flex-end;
    gap: 8px;
  }

  /* 列表卡片化：提升手机端可读性与可点性 */
  .admin-section {
    padding: 16px;
    margin-bottom: 16px;
  }

  .section-title {
    font-size: 16px;
    margin-bottom: 16px;
    padding-bottom: 10px;
  }

  .data-item {
    flex-direction: column;
    align-items: stretch !important;
    gap: 10px;
  }

  .data-item .item-content {
    width: 100%;
  }

  .data-item .item-info {
    width: 100%;
    min-width: 0;
  }

  .data-item .item-text {
    word-break: break-word;
  }

  .data-item.building-item {
    gap: 12px;
  }

  .building-thumb {
    width: 100% !important;
    height: auto !important;
    max-height: 220px;
    object-fit: cover;
  }

  .data-item.user-item .building-thumb {
    width: 56px !important;
    height: 56px !important;
  }

  .item-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .mc-btn-small {
    min-height: 40px;
  }

  /* 图片网格与上传队列适配 */
  .mc-image-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 8px !important;
  }

  .mc-image-tile {
    height: 120px !important;
  }

  .mc-image-uploading {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
  }

  .mc-image-uploading-item {
    padding: 8px !important;
  }

  /* 邮件纸张风格适配 */
  .mail-paper {
    width: calc(100vw - 16px) !important;
    margin: 8px !important;
  }

  .mail-paper-content {
    padding: 15px !important;
  }

  .mail-paper-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
    padding-bottom: 15px !important;
  }

  .mail-postmark {
    width: 60px !important;
    height: 60px !important;
    font-size: 9px !important;
    margin-bottom: 5px !important;
  }

  .mail-paper-row {
    flex-direction: column !important;
    gap: 4px !important;
    margin-bottom: 12px !important;
  }

  .mail-paper-row .label {
    width: auto !important;
    font-size: 11px !important;
  }

  .mail-paper-row .value {
    font-size: 13px !important;
  }

  .mail-text-content {
    font-size: 14px !important;
    line-height: 1.6 !important;
  }

  .mail-actions {
    flex-direction: column !important;
    width: 100% !important;
    gap: 10px !important;
  }

  .mail-actions .mc-btn {
    width: 100% !important;
  }

  /* 地图管理模块适配 */
  .map-toolbar {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
    padding: 12px !important;
  }

  .map-toolbar-right {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .map-container {
    height: 300px !important;
  }

  /* 更新日志时间线适配 */
  .update-timeline {
    padding-left: 25px !important;
  }

  .update-timeline::before {
    left: 4px !important;
  }

  .node-dot {
    left: -29px !important;
    width: 16px !important;
    height: 16px !important;
  }

  .node-content {
    padding: 12px !important;
  }

  .node-content::before {
    left: -10px !important;
    border-right-width: 6px !important;
  }

  .node-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 4px !important;
  }

  .node-version {
    font-size: 16px !important;
  }

  .node-date {
    font-size: 10px !important;
  }

  .node-actions {
    justify-content: flex-start !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
  }

  .node-actions .mc-btn-small {
    flex: 1 1 auto;
    text-align: center;
  }

  /* 地图上传弹窗精修 */
  .mc-modal input[type="file"] {
    width: 100%;
    font-size: 12px;
    padding: 8px 0;
  }

  .mc-modal img {
    max-height: 180px !important;
  }

  /* 弹窗通用滚动与键盘兜底 */
  .mc-modal {
    overscroll-behavior: contain;
    display: flex;
    flex-direction: column;
    padding-bottom: env(safe-area-inset-bottom, 20px) !important;
  }

  .modal-btns {
    flex-wrap: wrap !important;
    gap: 10px !important;
  }

  .modal-btns .mc-btn {
    flex: 1 1 calc(50% - 10px);
    min-width: 100px;
  }

  /* 邮件管理工具栏深度微调 */
  .mail-toolbar {
    border-width: 3px !important;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.35) !important;
  }

  .mail-toolbar-group {
    padding: 10px !important;
    min-width: 0 !important;
    border-bottom: 2px solid #000;
  }

  .mail-toolbar-group:last-child {
    border-bottom: none;
  }

  .toolbar-divider {
    display: none !important;
  }

  .mc-select-wrapper {
    min-width: 0 !important;
    flex: 1;
  }

  .mail-search {
    font-size: 14px !important; /* 防止 iOS 自动缩放 */
  }

  .action-group {
    flex-wrap: wrap;
    gap: 8px !important;
  }

  .action-group .mc-btn {
    flex: 1;
    min-width: 80px;
  }

  /* 针对 Admin 首页数据项的深度适配 */
  .admin-content {
    padding-bottom: 40px;
  }

  /* 用户、居民等列表项垂直排布 */
  .data-item {
    flex-direction: column !important;
    align-items: stretch !important;
    padding: 12px !important;
    gap: 12px !important;
  }

  .item-content {
    flex-direction: row !important; /* 头像与文字保持横向 */
    align-items: center !important;
  }

  .item-actions {
    width: 100% !important;
    justify-content: flex-end !important;
    border-top: 1px dashed rgba(0,0,0,0.1);
    padding-top: 10px;
    margin-top: 5px;
  }

  /* 建筑展示管理特别优化 */
  .building-item {
    display: flex !important;
    flex-direction: column !important;
  }

  .building-item .item-content {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px;
  }

  .building-thumb {
    width: 100% !important;
    height: 180px !important;
    border-radius: 4px;
  }

  /* 导航栏固定定位调整，防止遮挡内容 */
  .admin-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }

  /* 防止内容被键盘遮挡，增加底部安全区 */
  .mc-modal {
    margin-bottom: env(safe-area-inset-bottom, 20px);
  }

  /* 图片预览全屏适配 */
  .mc-image-preview-img {
    max-width: 95vw !important;
    max-height: 80vh !important;
  }
}

/* 兼容更小屏幕（如 iPhone SE） */
@media (max-width: 380px) {
  .admin-brand-title {
    font-size: 14px !important;
  }
  .nav-tab-btn {
    font-size: 12px !important;
    padding: 8px 6px !important;
  }
  .node-version {
    font-size: 14px !important;
  }
}

@media (max-width: 768px) {
  .mc-datepicker-panel {
    width: 280px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }

  .mc-datepicker-day {
    width: 35px !important;
    height: 35px !important;
    line-height: 35px !important;
  }

  .mc-image-tile-cover .mc-image-cover-label {
    font-size: 10px !important;
    padding: 2px 4px !important;
  }

  textarea.mc-input {
    font-size: 14px !important;
    line-height: 1.5 !important;
  }
}

.admin-nav {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 20px 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.92), rgba(0, 0, 0, 0.68));
  border-bottom: 4px solid #333;
}

.admin-nav-left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.admin-nav-tabs {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-tab-btn {
  position: relative;
  padding: 10px 18px;
  border: 4px solid #000;
  background:
    linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)),
    linear-gradient(180deg, #3a3a3a 0%, #151515 100%);
  color: rgba(255, 255, 255, 0.82);
  font-family: inherit;
  font-size: 12px;
  letter-spacing: 1px;
  text-shadow: 2px 2px 0 #000;
  box-shadow:
    inset -4px -4px 0 rgba(0, 0, 0, 0.45),
    inset 4px 4px 0 rgba(255, 255, 255, 0.06),
    8px 8px 0 rgba(0, 0, 0, 0.35);
  cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
  user-select: none;
}

.nav-tab-btn:hover {
  filter: brightness(1.06);
  transform: translateY(-1px);
}

.nav-tab-btn:active {
  transform: translateY(1px);
  box-shadow:
    inset -3px -3px 0 rgba(0, 0, 0, 0.45),
    inset 3px 3px 0 rgba(255, 255, 255, 0.06),
    5px 5px 0 rgba(0, 0, 0, 0.35);
}

.nav-tab-btn.active {
  background:
    linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
    linear-gradient(90deg, #2f7d1b 0 25%, #3e8f27 25% 50%, #2f7d1b 50% 75%, #3e8f27 75% 100%);
  color: #fff;
  border-color: #000;
  box-shadow:
    inset -4px -4px 0 #2d4a0b,
    inset 4px 4px 0 rgba(154, 224, 84, 0.20),
    10px 10px 0 rgba(0, 0, 0, 0.35);
}

.mc-nav-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border: 3px solid #000;
  background: linear-gradient(180deg, #ff5a5a 0%, #c40000 100%);
  color: #fff;
  font-size: 10px;
  line-height: 1;
  text-shadow: 1px 1px 0 #000;
  box-shadow: inset -2px -2px 0 rgba(0,0,0,0.35), inset 2px 2px 0 rgba(255,255,255,0.10), 4px 4px 0 rgba(0,0,0,0.35);
}

.admin-nav-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-brand-logo {
  width: 36px;
  height: 36px;
  border: 4px solid #000;
  background:
    linear-gradient(180deg,#5ea818 0,#3c6b10 50%,#2b5a0a 100%);
  box-shadow: inset -4px -4px 0 rgba(0,0,0,0.6), inset 4px 4px 0 rgba(255,255,255,0.18);
}

.admin-brand-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.admin-brand-title {
  font-size: 16px;
  color: #ffffff;
  font-weight: 700;
  text-shadow: 3px 3px 0 #000;
}

.admin-brand-sub {
  font-size: 10px;
  color: #9ae054;
  text-shadow: 2px 2px 0 #000;
}

.admin-nav-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-nav-actions .mc-nav-btn {
  border-color: #ff6b6b;
}

.admin-nav-actions .mc-nav-btn:hover {
  background: #ff6b6b;
  border-color: #ff6b6b;
}

.admin-nav h1 {
  font-size: 24px;
  margin: 0;
  text-shadow: 4px 4px 0 #000;
}

.back-link {
  text-decoration: none;
  color: #fff;
  font-size: 12px;
  padding: 10px 20px;
  border: 4px solid #fff;
  background: rgba(0, 0, 0, 0.5);
  transition: 0.3s;
}

.back-link:hover {
  background: var(--mc-green);
  border-color: var(--mc-green);
}

.admin-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
}

.admin-section {
  background: #1a1a1a;
  border: 4px solid #333;
  padding: 40px;
  margin-bottom: 40px;
  border-radius: 0;
  position: relative;
}

.section-title {
  font-size: 20px;
  color: var(--mc-green);
  margin-bottom: 30px;
  text-align: center;
  border-bottom: 3px solid var(--mc-green);
  padding-bottom: 15px;
}

.section-content {
  margin-top: 30px;
}

.data-list {
  margin-top: 20px;
}

/* ============ 邮件管理：信件列表 + 点击查看 ============ */
.mail-toolbar {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 0;
  padding: 0;
  margin: 20px 0 16px;
  border: 4px solid #000;
  background: #1a1a1a;
  box-shadow: 8px 8px 0 rgba(0, 0, 0, 0.35);
  overflow: hidden;
}

.mail-toolbar-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
}

.search-group {
  flex: 1 1 420px;
  min-width: 0;
}

.filter-group {
  flex: 1 1 360px;
  min-width: 0;
}

.action-group {
  flex: 0 0 auto;
  min-width: 0;
  margin-left: auto;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.group-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  user-select: none;
}

.toolbar-divider {
  width: 4px;
  align-self: stretch;
  background: #000;
  box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.05);
  flex-shrink: 0;
}

.mail-search {
  flex: 1;
  height: 34px;
  background: #000;
  border: 2px solid #333;
  color: #9ae054;
  font-family: inherit;
  font-size: 12px;
  padding: 0 10px;
}

.mc-select-wrapper {
  position: relative;
  height: 34px;
  min-width: 140px;
  flex: 1;
  border: 2px solid #000;
  background: #2a2a2a;
  box-shadow: inset -2px -2px 0 rgba(0,0,0,0.3);
}

.mc-select-wrapper::after {
  content: '';
  position: absolute;
  right: 8px;
  top: 50%;
  width: 0;
  height: 0;
  transform: translateY(-50%);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid #5ea818;
  pointer-events: none;
}

.select-display-text {
  position: absolute;
  left: 8px;
  right: 24px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 11px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}

.mail-select {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

.mail-select::-ms-expand {
  display: none;
}

.mail-select option {
  background-color: #1a1a1a !important;
  color: #ffffff !important;
}

.mail-toolbar .mc-btn {
  height: 34px;
  margin: 0;
  padding: 0 16px;
  font-size: 11px;
  min-width: 80px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  line-height: 1;
  white-space: nowrap;
}

.mail-toolbar .mc-btn-unread {
  min-width: 96px;
}

.mail-toolbar .mc-btn-unread.active {
  background: #5ea818;
  color: #fff;
  border-color: #000;
}

@media (max-width: 900px) {
  .toolbar-divider { display: none; }
  .mail-toolbar-group { border-bottom: 2px solid #000; width: 100%; }
}

.mail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.mail-card {
  position: relative;
  background: #e4d8c1; /* 复古信纸色 */
  border: 4px solid #000;
  box-shadow:
    inset -4px -4px 0 rgba(0,0,0,0.2),
    inset 4px 4px 0 rgba(255,255,255,0.4),
    12px 12px 0 rgba(0,0,0,0.35);
  padding: 24px 18px 18px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 190px;
}

.mail-card.mail-selected {
  background: #f0f8ff;
  border-color: #5ea818;
  /* 双层像素边框效果 */
  box-shadow: 
    0 0 0 4px #5ea818,
    0 0 0 8px #000,
    12px 12px 0 rgba(0, 0, 0, 0.35);
  transform: translate(4px, 4px); /* 更明显的下沉感 */
}

/* 绿色覆盖层与选中纹理 */
.mail-card.mail-selected::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(94, 168, 24, 0.2) 25%, transparent 25%, transparent 50%, rgba(94, 168, 24, 0.2) 50%, rgba(94, 168, 24, 0.2) 75%, transparent 75%, transparent);
  background-size: 20px 20px; /* 像素斜纹 */
  pointer-events: none;
  z-index: 5;
  animation: mc-selected-pulse 2s infinite linear;
}

@keyframes mc-selected-pulse {
  0% { opacity: 0.6; }
  50% { opacity: 0.9; }
  100% { opacity: 0.6; }
}

/* 选中后的打钩图标增强 */
.mail-card.mail-selected .mail-select-box {
  background: #5ea818;
  border-color: #fff;
  transform: scale(1.2);
  box-shadow: 0 0 10px #5ea818;
}

/* 信封边缘斜纹装饰 */
.mail-card::before {
  content: '';
  position: absolute;
  inset: 0;
  border: 12px solid transparent;
  border-image: repeating-linear-gradient(
    -45deg,
    #ff4b4b 0, #ff4b4b 10px,
    #fff 10px, #fff 20px,
    #4b83ff 20px, #4b83ff 30px,
    #fff 30px, #fff 40px
  ) 12;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

/* 像素风信封翻盖 */
.mail-envelope-flap {
  position: absolute;
  top: 10px;
  left: 14px;
  right: 14px;
  height: 44px;
  background: rgba(0, 0, 0, 0.05);
  clip-path: polygon(
    0 0,
    100% 0,
    100% 8px,
    50% 100%,
    0 8px
  );
  border: 3px solid rgba(0,0,0,0.18);
  box-shadow: inset -2px -2px 0 rgba(0,0,0,0.10), inset 2px 2px 0 rgba(255,255,255,0.20);
  image-rendering: pixelated;
  z-index: 0;
}

/* 信封背面折痕（已移除交叉线，保持干净） */
.mail-envelope-crease {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  background: none;
}

/* 信封底部封口阴影条（像素风） */
.mail-card::after {
  content: '';
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 14px;
  height: 12px;
  background:
    linear-gradient(180deg, rgba(0,0,0,0.18), rgba(0,0,0,0));
  border-top: 3px solid rgba(0,0,0,0.12);
  box-shadow: inset 0 3px 0 rgba(255,255,255,0.12);
  pointer-events: none;
  z-index: 0;
}
.mail-card:hover {
  transform: translateY(-6px) rotate(1deg);
  background: #ece3d1;
  box-shadow:
    inset -4px -4px 0 rgba(0,0,0,0.15),
    inset 4px 4px 0 rgba(255,255,255,0.5),
    16px 16px 0 rgba(0,0,0,0.25);
}

.mail-card.mail-read {
  filter: sepia(0.3) brightness(0.9);
  background: #d8ceb8;
}

/* 像素风火漆印章 */
.mail-status-seal {
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: 50px;
  height: 50px;
  border: 4px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 900;
  transform: rotate(-12deg);
  z-index: 3;
  box-shadow: 4px 4px 0 rgba(0,0,0,0.3);
  transition: all 0.2s;
  image-rendering: pixelated;
}

.mail-status-seal.unread {
  background: #d44c4c;
  color: #fff;
  /* 像素圆效果：通过 clip-path 模拟八角像素圆 */
  clip-path: polygon(
    20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%
  );
  border: 4px solid #000;
  animation: sealPulse 2s infinite steps(2);
}

.mail-status-seal.read {
  background: rgba(0,0,0,0.05);
  color: rgba(0,0,0,0.3);
  border: 3px dashed rgba(0,0,0,0.25);
  box-shadow: none;
  clip-path: none;
  transform: rotate(0deg);
}

.mail-status-seal.replied {
  background: #2f7d1b;
  color: #fff;
  /* 像素方章效果 */
  clip-path: inset(0 0 0 0);
  border: 4px solid #000;
  box-shadow: 4px 4px 0 rgba(0,0,0,0.2);
}

@keyframes sealPulse {
  0%, 100% { transform: rotate(-12deg) scale(1); }
  50% { transform: rotate(-12deg) scale(1.1); }
}

@keyframes sealPulse {
  0%, 100% { transform: rotate(-12deg) scale(1); }
  50% { transform: rotate(-12deg) scale(1.08); }
}

.mail-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid rgba(0,0,0,0.1);
  padding-bottom: 8px;
}

.mail-card-nickname {
  font-size: 15px;
  color: #3e2b16;
  font-weight: 800;
  margin-bottom: 4px;
}

.mail-card-preview {
  font-size: 13px;
  color: #5d4a36;
  line-height: 1.5;
  font-style: italic;
}

.mail-card-type {
  font-size: 10px;
  background: #3e2b16;
  color: #fff;
  padding: 2px 8px;
}

.mail-card::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  height: 14px;
  background:
    linear-gradient(90deg, rgba(94,168,24,0.25), rgba(94,168,24,0.05));
  border: 4px solid #000;
  border-bottom: 0;
}

/* 按类型给封条分色（兼容未知 type：默认绿色） */
.mail-card.mail-type-bug::before,
.mail-card.mail-type-举报::before,
.mail-card.mail-type-report::before {
  background: linear-gradient(90deg, rgba(255, 90, 90, 0.35), rgba(255, 90, 90, 0.08));
}

.mail-card.mail-type-建议::before,
.mail-card.mail-type-suggest::before {
  background: linear-gradient(90deg, rgba(94, 168, 24, 0.35), rgba(94, 168, 24, 0.08));
}

.mail-card.mail-type-反馈::before,
.mail-card.mail-type-feedback::before {
  background: linear-gradient(90deg, rgba(80, 160, 255, 0.35), rgba(80, 160, 255, 0.08));
}

.mail-card.mail-type-其它::before,
.mail-card.mail-type-other::before {
  background: linear-gradient(90deg, rgba(180, 180, 180, 0.28), rgba(180, 180, 180, 0.06));
}

.mail-card:hover {
  transform: translateY(-2px);
  filter: brightness(1.06);
}

.mail-card:active {
  transform: translateY(0px);
  filter: brightness(1.02);
}

.mail-card.mail-read {
  filter: grayscale(1) brightness(0.75) contrast(0.95);
}

.mail-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 8px;
}

.mail-card-type {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 8px;
  border: 3px solid #000;
  background: #3b3b3b;
  color: rgba(255,255,255,0.9);
  font-size: 10px;
  text-shadow: 1px 1px 0 #000;
}

.mail-member-badge {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 8px;
  border: 3px solid #000;
  background: linear-gradient(180deg, #5ea818 0%, #2f7d1b 100%);
  color: #fff;
  font-size: 10px;
  text-shadow: 1px 1px 0 #000;
  box-shadow: inset -2px -2px 0 rgba(0, 0, 0, 0.35), inset 2px 2px 0 rgba(255, 255, 255, 0.18);
  margin-left: 8px;
}

.mail-card {
  position: relative;
  outline: none; /* 去除默认焦点轮廓 */
  user-select: none;
}

.mail-card:focus {
  outline: none;
}

.mail-card-time {
  font-size: 10px;
  color: rgba(255,255,255,0.65);
}

.mail-card-body {
  margin-top: 10px;
}

.mail-card-nickname {
  font-size: 14px;
  color: #9ae054;
  text-shadow: 2px 2px 0 #000;
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}

.mail-card-preview {
  font-size: 12px;
  color: rgba(255,255,255,0.85);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 3.9em;
}

.mail-card-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.mail-status-tag {
  font-size: 10px;
  padding: 2px 8px;
  border: 3px solid #000;
  text-shadow: 1px 1px 0 #000;
}

.mail-status-tag.unread {
  background: linear-gradient(180deg, #ff5a5a 0%, #c40000 100%);
  color: #fff;
}

.mail-status-tag.read {
  background: linear-gradient(180deg, #606060 0%, #3b3b3b 100%);
  color: rgba(255,255,255,0.8);
}

.mail-detail-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.78);
  backdrop-filter: blur(4px);
}

.mail-detail-overlay.active {
  display: flex;
}

.mail-paper {
  width: min(720px, calc(100vw - 40px));
  max-height: calc(100vh - 80px);
  overflow: auto;
  border: 6px solid #000;
  background:
    repeating-linear-gradient(
      0deg,
      rgba(0,0,0,0.03),
      rgba(0,0,0,0.03) 1px,
      rgba(255,255,255,0.02) 1px,
      rgba(255,255,255,0.02) 5px
    ),
    linear-gradient(180deg, #eadbbd 0%, #ddcaa7 100%);
  box-shadow: 18px 18px 0 rgba(0,0,0,0.45);
  color: #2d1f12;
  font-family: "Courier New", Courier, "PingFang SC", "Microsoft YaHei", monospace;
}

.mail-paper-content {
  padding: 30px;
}

.mail-paper-header {
  display: flex;
  gap: 24px;
  padding-bottom: 20px;
  border-bottom: 2px dashed rgba(45,31,18,0.3);
  align-items: center;
}

.mail-postmark {
  flex: 0 0 auto;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 4px double rgba(45,31,18,0.6);
  color: rgba(45,31,18,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  transform: rotate(-12deg);
  opacity: 0.8;
  line-height: 1.2;
  text-align: center;
}

.mail-paper-meta {
  flex: 1;
  font-size: 14px;
}

.mail-paper-row {
  display: flex;
  gap: 15px;
  margin-bottom: 8px;
  align-items: flex-start;
}

.mail-paper-row .label {
  width: 90px;
  flex-shrink: 0;
  opacity: 0.6;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.mail-paper-row .value {
  font-weight: 700;
  color: #1a110a;
  word-break: break-all;
}

.mail-paper-body {
  padding: 24px 0 0;
}

.mail-text-content {
  white-space: pre-wrap;
  line-height: 1.8;
  font-size: 16px;
  letter-spacing: 0.5px;
}

.mail-paper-reply {
  margin-top: 16px;
  padding: 12px 12px;
  background: rgba(255,255,255,0.35);
  border: 2px solid rgba(45,31,18,0.25);
}

.reply-divider {
  height: 2px;
  background: rgba(45,31,18,0.25);
  margin-bottom: 10px;
}

.reply-title {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
  margin-bottom: 6px;
}

.reply-text {
  white-space: pre-wrap;
  line-height: 1.6;
  font-size: 13px;
}

.mail-paper-footer {
  padding-top: 16px;
}

.mail-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}


.mail-paper-fade-enter-active,
.mail-paper-fade-leave-active {
  transition: all 0.22s ease;
}

.mail-paper-fade-enter-from,
.mail-paper-fade-leave-to {
  opacity: 0;
  transform: translateY(10px) scale(0.985);
}

.data-item {
  background: #222;
  border: 3px solid #444;
  padding: 20px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.building-item {
  align-items: center;
}

.building-thumb {
  width: 100px;
  height: 60px;
  object-fit: cover;
  margin-right: 15px;
  border: 2px solid #444;
}

/* 用户管理头像：正方形，列表行高度随头像适配 */
.data-item.user-item {
  align-items: center;
}

.data-item.user-item .building-thumb {
  width: 64px;
  height: 64px;
  object-fit: cover;
  flex: 0 0 64px;
  margin-right: 15px;
}

.item-content {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 15px;
}

.item-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.item-text {
  font-size: 14px;
  color: #fff;
}

.item-meta {
  font-size: 10px;
  color: #888;
}

.item-type {
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 0;
}

.type-top {
  background: #ff6b6b;
  color: #fff;
}

.type-security {
  background: #4ecdc4;
  color: #fff;
}

.type-infrastructure {
  background: #ffe66d;
  color: #000;
}

.type-normal {
  background: #95a5a6;
  color: #fff;
}

.type-custom {
  background: #9b59b6;
  color: #fff;
}

.item-actions {
  display: flex;
  gap: 10px;
}

.mc-btn-small {
  padding: 8px 16px;
  border: 3px solid #000;
  font-family: inherit;
  background: #999;
  box-shadow: inset -2px -2px 0 #555, inset 2px 2px 0 #ddd;
  font-size: 10px;
  cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
}

.mc-btn-small.mc-btn-danger {
  background: #e74c3c;
  box-shadow: inset -2px -2px 0 #c0392b, inset 2px 2px 0 #ec7063;
  color: white;
}

.map-preview {
  margin: 20px 0;
  border: 4px solid #333;
  background: #000;
}

.map-container {
  width: 100%;
  height: 400px;
}

/* 确保所有模态框层级低于提示框（避免遮挡 toast） */
.mc-modal-mask {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 1000000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  pointer-events: none; /* PC端默认不拦截点击 */
}

.mc-modal-mask.active {
  opacity: 1;
  visibility: visible;
  pointer-events: auto; /* 激活时拦截点击 */
}

/* 仅在移动端显示背景遮罩 */
@media (max-width: 768px) {
  .mc-modal-mask {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    align-items: flex-start; /* 手机端顶部对齐 */
    padding: 20px 10px;
    overflow-y: auto;
  }
}

.mc-modal {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  margin: 0;
  transform: scale(0.96);
  background: #c6c6c6;
  border: 6px solid #000;
  padding: 30px;
  z-index: 1000001;
  box-shadow: inset -4px -4px 0 #555, inset 4px 4px 0 #fff;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 500px;
  max-height: 90vh;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s cubic-bezier(0.18, 0.89, 0.32, 1.28), visibility 0s linear 0.18s;
}

.mc-modal-scroll {
  flex: 1;
  overflow-y: auto;
}

/* 确保“建筑原因”弹窗永远在最上层，避免被 building-modal 遮挡 */
.mc-modal.building-reason-modal {
  z-index: 1000002;
}

.mc-modal.building-modal {
  width: 600px;
}

.mc-modal.active {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: scale(1);
  transition: opacity 0.18s ease, transform 0.18s cubic-bezier(0.18, 0.89, 0.32, 1.28), visibility 0s;
}

@media (max-width: 768px) {
  .mc-modal {
    position: relative; /* 手机端取消 fixed 居中，改为随 mask 布局 */
    top: 0;
    left: 0;
    transform: none;
    width: 100%;
    padding: 15px;
    border-width: 4px;
    max-height: none; /* 滚动由外部 mask 处理 */
    gap: 10px;
    opacity: 1; /* 由 mask 控制可见性 */
    visibility: visible;
    pointer-events: auto;
  }

  .mc-modal.active {
    transform: none;
  }

  .mc-modal h3 {
    font-size: 13px !important;
  }

  .mc-modal .mc-input {
    padding: 8px 10px;
    font-size: 11px;
  }

  .mc-modal .modal-btns {
    margin-top: 10px;
    padding-top: 8px;
  }

  .mc-modal .mc-btn {
    padding: 10px;
    font-size: 12px;
  }

  .mc-modal-scroll {
    padding-right: 4px;
    -webkit-overflow-scrolling: touch;
  }
}

.modal-btns {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 3px solid rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

.mc-btn {
  padding: 12px;
  border: 3px solid #000;
  font-family: inherit;
  background: #999;
  box-shadow: inset -3px -3px 0 #555, inset 3px 3px 0 #ddd;
  flex: 1;
  cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
}

.mc-btn-primary {
  background: var(--mc-green);
  box-shadow: inset -3px -3px 0 #3c6b10, inset 3px 3px 0 #9ae054;
  color: white;
}

#toast {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: -120px;
  background: #000;
  border: 4px solid #fff;
  padding: 20px 40px;
  z-index: 1000000;
  transition: 0.5s;
  opacity: 0;
  pointer-events: none;
}

#toast.active {
  bottom: 60px;
  opacity: 1;
}

.mc-banner-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mc-banner-flag {
  width: calc(14px * var(--map-scale));
  height: calc(20px * var(--map-scale));
  background: #fff;
  border: calc(2px * var(--map-scale)) solid #000;
  position: relative;
}

.mc-banner-flag::after {
  content: '';
  position: absolute;
  bottom: calc(-6px * var(--map-scale));
  left: calc(-2px * var(--map-scale));
  border-left: calc(7px * var(--map-scale) + 1px) solid transparent;
  border-right: calc(7px * var(--map-scale) + 1px) solid transparent;
  border-top: calc(6px * var(--map-scale)) solid #000;
}

.mc-banner-text {
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  font-family: 'Microsoft YaHei';
  font-size: calc(12px * var(--map-scale));
  margin-top: 4px;
  white-space: nowrap;
}


.map-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.map-toolbar-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.mc-switch {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
  user-select: none;
}

.mc-switch-track {
  width: 52px;
  height: 28px;
  background: #555;
  border: 3px solid #000;
  box-shadow: inset 2px 2px 0 #333;
  position: relative;
}

.mc-switch-thumb {
  width: 22px;
  height: 22px;
  background: #999;
  border: 3px solid #000;
  box-shadow: inset -2px -2px 0 #555, inset 2px 2px 0 #ddd;
  position: absolute;
  top: -3px;
  left: -3px;
  transition: transform 0.2s ease-out;
}

.mc-switch.on .mc-switch-track {
  background: var(--mc-green);
  box-shadow: inset 2px 2px 0 #3c6b10;
}

.mc-switch.on .mc-switch-thumb {
  transform: translateX(24px);
}

.mc-switch-label {
  font-size: 12px;
  color: #fff;
}

.map-lock-hint {
  font-size: 10px;
  color: #888;
}

.mc-image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-top: 10px;
  padding: 10px;
  background: #1b1b1b;
  border: 3px solid #000;
  box-shadow: inset -2px -2px 0 #555, inset 2px 2px 0 #2a2a2a;
}

.mc-image-tile {
  position: relative;
  border: 3px solid #000;
  background: #111;
  box-shadow: inset -2px -2px 0 #444, inset 2px 2px 0 #222;
  padding: 6px;
  cursor: move;
}

.mc-image-tile-cover {
  border: 3px dashed #5ea818;
  background: #1a2e0a;
}

.mc-image-cover-label {
  position: absolute;
  top: 6px;
  left: 6px;
  background: #5ea818;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border: 2px solid #000;
  pointer-events: none;
}

.mc-image-thumb {
  width: 100%;
  height: 74px;
  object-fit: cover;
  border: 2px solid #000;
  background: #000;
  display: block;
  cursor: zoom-in;
}

.mc-image-uploading {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.mc-image-uploading-item {
  position: relative;
  width: 100px;
  height: 100px;
  border: 2px dashed #666;
  background: #222;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mc-image-uploading-item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.mc-image-uploading-label {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 10px;
  color: #9ae054;
  background: rgba(0,0,0,0.7);
  padding: 2px;
}

.mc-image-retry-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #a00;
  color: #fff;
  border: 2px solid #000;
  padding: 2px 6px;
  font-size: 10px;
  cursor: pointer;
}

.mc-image-retry-btn:hover {
  background: #c00;
}

.mc-image-remove-btn {
  position: absolute;
  top: 4px;
  left: 4px;
  background: #555;
  color: #fff;
  border: 2px solid #000;
  padding: 2px 6px;
  font-size: 10px;
  cursor: pointer;
}

.mc-image-remove-btn:hover {
  background: #777;
}

.mc-image-preview {
  z-index: 10000000;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 10000000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;

  opacity: 0;
  visibility: hidden;
  transition: opacity 0.22s ease, visibility 0.22s ease;
}

.mc-image-preview.active {
  opacity: 1;
  visibility: visible;
}

.mc-image-preview-img {
  max-width: min(1200px, 96vw);
  max-height: 92vh;
  border: 6px solid #fff;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.8);
  background: #000;
  object-fit: contain;

  transform: scale(0.92);
  opacity: 0;
  transition: transform 0.22s cubic-bezier(0.2, 0.9, 0.2, 1), opacity 0.22s ease;
}

.mc-image-preview.active .mc-image-preview-img {
  transform: scale(1);
  opacity: 1;
}

.mc-image-preview-close {
  position: fixed;
  top: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  border: 4px solid #fff;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 24px;
  line-height: 34px;
  padding: 0;
  cursor: pointer;
}

.mc-image-del {
  margin-top: 6px;
  width: 100%;
  padding: 6px 8px;
  border: 3px solid #000;
  font-family: inherit;
  background: #e74c3c;
  box-shadow: inset -2px -2px 0 #c0392b, inset 2px 2px 0 #ec7063;
  color: #fff;
  font-size: 10px;
  cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
}

/* 分类查看控件 - Minecraft 风格 */
.mc-filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding: 16px;
  background: linear-gradient(135deg, #1e1e1e 0%, #2d2d2d 50%, #1e1e1e 100%);
  border: 4px solid #4a4a4a;
  border-radius: 8px;
  box-shadow: 
    0 0 0 2px #000,
    0 0 0 4px #4a4a4a,
    0 0 0 6px #000,
    0 6px 20px rgba(0, 0, 0, 0.8),
    inset 0 1px 2px rgba(255, 255, 255, 0.1),
    inset 0 -1px 2px rgba(0, 0, 0, 0.3);
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
}

.mc-filter-title {
  font-size: 14px;
  color: #5de7ff;
  font-family: 'Press Start 2P', 'Courier New', monospace;
  text-shadow: 
    0 0 6px rgba(93, 231, 255, 0.6),
    2px 2px 0 #000,
    4px 4px 0 rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
  margin-right: 8px;
}

.mc-filter-btn {
  padding: 8px 16px;
  border: 3px solid #4a4a4a;
  font-family: 'Press Start 2P', 'Courier New', monospace;
  font-size: 10px;
  font-weight: bold;
  background: linear-gradient(135deg, #2a2a2a, #3a3a3a);
  color: #ccc;
  cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
  box-shadow: 
    4px 4px 0 #000,
    inset 0 1px 2px rgba(255, 255, 255, 0.1),
    inset 0 -1px 2px rgba(0, 0, 0, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.2s ease;
  position: relative;
  top: 0;
  left: 0;
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
}

.mc-filter-btn:hover {
  background: linear-gradient(135deg, #3a3a3a, #4a4a4a);
  color: #fff;
  transform: translate(2px, 2px);
  box-shadow: 2px 2px 0 #000;
}

.mc-filter-btn:active {
  transform: translate(4px, 4px);
  box-shadow: 0 0 0 #000;
}

.mc-filter-btn.active {
  background: linear-gradient(135deg, #5ea818, #6fb91f);
  color: #fff;
  border-color: #4a7c12;
  box-shadow: 
    4px 4px 0 #2d4a0b,
    inset 0 1px 2px rgba(255, 255, 255, 0.2),
    inset 0 -1px 2px rgba(0, 0, 0, 0.2);
}

.mc-filter-btn.active:hover {
  background: linear-gradient(135deg, #6fb91f, #7fc92f);
  transform: translate(2px, 2px);
  box-shadow: 2px 2px 0 #2d4a0b;
}

/* 用户昵称标签 - Minecraft 风格 */
.mc-user-tag {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  font-family: 'Press Start 2P', 'Courier New', monospace;
  font-size: 10px;
  line-height: 1;
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
}

.mc-user-tag-dash {
  color: #ff6b6b;
  font-weight: bold;
  margin-right: 4px;
  text-shadow: 
    0 0 4px rgba(255, 107, 107, 0.8),
    1px 1px 0 #000;
}

.mc-user-tag-name {
  background: linear-gradient(135deg, #ff6b6b, #ff5252);
  color: #fff;
  padding: 2px 6px;
  border: 2px solid #000;
  border-radius: 0;
  box-shadow: 
    2px 2px 0 #000,
    inset 0 1px 2px rgba(255, 255, 255, 0.2),
    inset 0 -1px 2px rgba(0, 0, 0, 0.3);
  text-shadow: 1px 1px 0 #000;
  font-weight: bold;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}

/* 像素风格闪烁效果 */
.mc-user-tag-name::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.15), transparent);
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.mc-user-tag-name:hover::before {
  opacity: 1;
  animation: mcUserTagShine 0.6s ease-out;
}

@keyframes mcUserTagShine {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* Minecraft 风格未知按钮 */
/* 自定义像素风日期选择器面板 */
.mc-datepicker-container {
  position: relative;
  flex: 1;
}

.mc-datepicker-panel {
  position: absolute;
  top: 100%;
  left: 0;
  width: 280px;
  background: #1e1e1e;
  border: 4px solid #3c3c3c;
  box-shadow: 0 8px 16px rgba(0,0,0,0.8), inset 0 0 0 2px #000;
  z-index: 2000;
  margin-top: 8px;
  padding: 10px;
  font-family: 'Press Start 2P', cursive;
  image-rendering: pixelated;
}

.mc-datepicker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 2px solid #3c3c3c;
}

.mc-datepicker-btn {
  background: #3c3c3c;
  color: #fff;
  border: none;
  padding: 4px 8px;
  font-size: 10px;
  cursor: pointer;
}

.mc-datepicker-btn:hover {
  background: #5ea818;
}

.mc-datepicker-title {
  font-size: 10px;
  color: #5ea818;
}

.mc-datepicker-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 8px;
  color: #888;
  margin-bottom: 5px;
}

.mc-datepicker-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.mc-datepicker-day {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: #fff;
  cursor: pointer;
  border: 2px solid transparent;
}

.mc-datepicker-day:hover {
  background: #3c3c3c;
  border-color: #5ea818;
}

.mc-datepicker-day.active {
  background: #5ea818;
  color: #000;
}

.mc-datepicker-day.empty {
  cursor: default;
}

.mc-datepicker-footer {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 2px solid #3c3c3c;
}

.mc-datepicker-footer-btn {
  flex: 1;
  background: #3c3c3c;
  color: #fff;
  border: none;
  padding: 6px 8px;
  font-size: 9px;
  cursor: pointer;
  text-align: center;
}

.mc-datepicker-footer-btn:hover {
  background: #5ea818;
  color: #000;
}

.mc-datepicker-footer-btn.clear:hover {
  background: #ff3b30;
  color: #000;
}

.date-input-group {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 15px;
}

.mc-unknown-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 4px solid #000;
  background: linear-gradient(180deg, #8b8b8b 0%, #6a6a6a 55%, #4a4a4a 100%);
  box-shadow: 
    inset -4px -4px 0 rgba(0,0,0,0.4),
    inset 4px 4px 0 rgba(255,255,255,0.15),
    0 8px 20px rgba(0,0,0,0.6);
  cursor: pointer;
  transition: transform 0.08s ease, filter 0.12s ease, box-shadow 0.12s ease;
  position: relative;
  font-family: 'Courier New', monospace;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  min-width: 120px;
  justify-content: center;
}

.mc-unknown-btn:hover:not(:disabled) {
  filter: brightness(1.08);
  box-shadow: 
    inset -4px -4px 0 rgba(0,0,0,0.35),
    inset 4px 4px 0 rgba(255,255,255,0.18),
    0 10px 26px rgba(0,0,0,0.65);
  transform: translateY(-1px);
}

.mc-unknown-btn:active:not(:disabled) {
  transform: translateY(1px);
  box-shadow: 
    inset -3px -3px 0 rgba(0,0,0,0.35),
    inset 3px 3px 0 rgba(255,255,255,0.12),
    0 6px 16px rgba(0,0,0,0.55);
}

.mc-unknown-btn.active {
  background: linear-gradient(180deg, #5ea818 0%, #4a8c14 55%, #366b0f 100%);
  border-color: #2d4a0b;
  box-shadow: 
    0 0 0 3px rgba(94,168,24,0.25),
    0 0 20px rgba(94,168,24,0.20),
    inset -4px -4px 0 rgba(45,74,11,0.4),
    inset 4px 4px 0 rgba(154,224,84,0.25);
  animation: mcUnknownGlow 2s ease-in-out infinite;
}

@keyframes mcUnknownGlow {
  0%, 100% { 
    box-shadow: 
      0 0 0 3px rgba(94,168,24,0.25),
      0 0 20px rgba(94,168,24,0.20),
      inset -4px -4px 0 rgba(45,74,11,0.4),
      inset 4px 4px 0 rgba(154,224,84,0.25);
  }
  50% { 
    box-shadow: 
      0 0 0 3px rgba(94,168,24,0.35),
      0 0 28px rgba(94,168,24,0.30),
      inset -4px -4px 0 rgba(45,74,11,0.4),
      inset 4px 4px 0 rgba(154,224,84,0.25);
  }
}

.mc-unknown-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #000;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  text-shadow: 0 0 4px rgba(255,255,255,0.8);
  border: 2px solid #444;
  box-shadow: 
    inset 0 0 0 1px rgba(255,255,255,0.3),
    0 0 8px rgba(0,0,0,0.4);
}

.mc-unknown-text {
  font-size: 12px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  letter-spacing: 0.5px;
}

.mc-unknown-btn.active .mc-unknown-icon {
  background: #5ea818;
  border-color: #2d4a0b;
  animation: mcUnknownIconPulse 1.5s ease-in-out infinite;
}

@keyframes mcUnknownIconPulse {
  0%, 100% { 
    transform: scale(1);
    box-shadow: 
      inset 0 0 0 1px rgba(255,255,255,0.3),
      0 0 8px rgba(94,168,24,0.6);
  }
  50% { 
    transform: scale(1.1);
    box-shadow: 
      inset 0 0 0 1px rgba(255,255,255,0.5),
      0 0 12px rgba(94,168,24,0.8);
  }
}

/* 响应式优化 */
@media (max-width: 768px) {
  .mc-filter-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px;
  }
  
  .mc-filter-btn {
    font-size: 9px;
    padding: 6px 12px;
  }
  
  .mc-user-tag {
    margin-left: 4px;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
  
  .mc-user-tag-dash {
    margin-right: 0;
  }

  .date-input-group {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .mc-unknown-btn {
    min-width: auto;
    width: 100%;
  }
}
</style>

